import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT, formatDate } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, NgModule, inject, DestroyRef, Injector, signal, Input, ViewChildren, EventEmitter, computed, Output, ViewChild, Pipe, input, output, ChangeDetectorRef, Directive, RendererFactory2, EnvironmentInjector, ApplicationRef, createComponent, Injectable, Inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i2 from '@angular/forms';
import { FormControl, NgControl, FormControlName, FormGroupDirective, Validators, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { generateUniqueId, GARMIN_CDN_URL, FlyGarminLegacyBaseUrl } from '@garmin-avcloud/avcloud-fly-web-common/_shared';
import { fromEvent, skip, Observable, debounceTime, take, of, catchError, throwError, forkJoin, tap, map } from 'rxjs';
import { __decorate } from 'tslib';
import { FLY_WEB_COMMON_CONFIG } from '@garmin-avcloud/avcloud-fly-web-common/config';
import * as i1$1 from '@angular/router';
import { RouterModule, RouterLink } from '@angular/router';
import { AircraftReadOnlyControllerService } from '@garmin-avcloud/avcloud-fly-web-common/api/aircraft/read';
import { YarmouthConnextValidationService } from '@garmin-avcloud/avcloud-fly-web-common/api/yarmouth';
import { CookieService, LocalStorageService, LocalStorageKey } from '@garmin-avcloud/avcloud-web-utils';
import { HttpClient } from '@angular/common/http';
import { OrganizationReadOnlyControllerService } from '@garmin-avcloud/avcloud-fly-web-common/api/orgs-roles/read';

/* eslint-disable */
/* tslint:disable */
const _c0 = ["*"];
const _c1 = ["option"];
function AutoCompleteInputComponent_Conditional_2_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 6, 0);
    i0.ɵɵlistener("click", function AutoCompleteInputComponent_Conditional_2_For_2_Template_li_click_0_listener() {
      const option_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleOptionSelected(option_r2));
    })("keydown.enter", function AutoCompleteInputComponent_Conditional_2_For_2_Template_li_keydown_enter_0_listener() {
      const option_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleOptionSelected(option_r2));
    })("keydown.arrowdown", function AutoCompleteInputComponent_Conditional_2_For_2_Template_li_keydown_arrowdown_0_listener($event) {
      const ɵ$index_8_r4 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.focusNextOption($event, ɵ$index_8_r4));
    })("keydown.arrowup", function AutoCompleteInputComponent_Conditional_2_For_2_Template_li_keydown_arrowup_0_listener($event) {
      const ɵ$index_8_r4 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.focusPreviousOption($event, ɵ$index_8_r4));
    })("keydown.home", function AutoCompleteInputComponent_Conditional_2_For_2_Template_li_keydown_home_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.focusFirstOption($event));
    })("keydown.end", function AutoCompleteInputComponent_Conditional_2_For_2_Template_li_keydown_end_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.focusLastOption($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", option_r2.displayText, " ");
  }
}
function AutoCompleteInputComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 4);
    i0.ɵɵrepeaterCreate(1, AutoCompleteInputComponent_Conditional_2_For_2_Template, 3, 1, "li", 5, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("non-empty", ctx_r2.filteredOptions().length > 0);
    i0.ɵɵproperty("id", ctx_r2.listId);
    i0.ɵɵattribute("aria-label", ctx_r2.label + " Options");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.filteredOptions());
  }
}
const _c2 = ["fileUpload"];
function ImageUploadComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-error", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.errorId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.error, " ");
  }
}
const _c3 = ["modal"];
function ModalComponent_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function ModalComponent_Conditional_3_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.close());
    });
    i0.ɵɵelement(1, "fly-icon", 8);
    i0.ɵɵelementEnd();
  }
}
function ModalComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "h1");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ModalComponent_Conditional_3_Conditional_3_Template, 2, 0, "button", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.header);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.showCloseBtn ? 3 : -1);
  }
}
function ModalComponent_Conditional_6_For_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 12);
  }
}
function ModalComponent_Conditional_6_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 11);
    i0.ɵɵpipe(1, "flyModalButtonTheme");
    i0.ɵɵlistener("click", function ModalComponent_Conditional_6_For_2_Template_g_button_click_0_listener() {
      const button_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(button_r5.action === "close" ? ctx_r2.close() : button_r5.action());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ModalComponent_Conditional_6_For_2_Conditional_4_Template, 1, 0, "g-loader", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r5 = ctx.$implicit;
    i0.ɵɵproperty("theme", i0.ɵɵpipeBind1(1, 5, button_r5));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("hidden", button_r5.loading);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(button_r5.text);
    i0.ɵɵadvance();
    i0.ɵɵconditional(button_r5.loading ? 4 : -1);
  }
}
function ModalComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵrepeaterCreate(1, ModalComponent_Conditional_6_For_2_Template, 5, 7, "g-button", 10, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("center-buttons", ctx_r2.alwaysCenterButtons);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.buttons);
  }
}
function SelectFilesComponent_Conditional_12_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 12);
    i0.ɵɵlistener("click", function SelectFilesComponent_Conditional_12_For_5_Template_button_click_3_listener() {
      const file_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.deleteFile(ctx_r4.selectedFiles.indexOf(file_r4)));
    });
    i0.ɵɵelement(4, "fly-icon", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const file_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(file_r4.name);
  }
}
function SelectFilesComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "strong");
    i0.ɵɵtext(3, "Selected Files:");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(4, SelectFilesComponent_Conditional_12_For_5_Template, 5, 1, "div", 10, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r4.selectedFiles);
  }
}
const _c4 = ["tabsInnerContainer"];
const _c5 = () => ({
  exact: true
});
function TabsComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function TabsComponent_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.scrollLeft());
    });
    i0.ɵɵelement(1, "img", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r1.config.regaliaIconsPath + "/arrow-right/icon.svg", i0.ɵɵsanitizeUrl);
  }
}
function TabsComponent_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_13_0;
    const tab_r3 = ctx.$implicit;
    i0.ɵɵproperty("routerLink", tab_r3.route)("routerLinkActiveOptions", (tmp_13_0 = tab_r3.isActiveMatchOptions) !== null && tmp_13_0 !== undefined ? tmp_13_0 : i0.ɵɵpureFunction0(3, _c5));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tab_r3.displayText, " ");
  }
}
function TabsComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function TabsComponent_Conditional_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.scrollRight());
    });
    i0.ɵɵelement(1, "img", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r1.config.regaliaIconsPath + "/arrow-right/icon.svg", i0.ɵɵsanitizeUrl);
  }
}
const _c6 = (a0, a1) => ({
  wizardStep: a0,
  index: a1
});
function WizardHeaderComponent_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function WizardHeaderComponent_For_1_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const $index_r2 = i0.ɵɵnextContext().$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.stepIndexSelected.emit($index_r2));
    });
    i0.ɵɵelementContainer(1, 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const wizardStep_r5 = ctx_r3.$implicit;
    const $index_r2 = ctx_r3.$index;
    i0.ɵɵnextContext();
    const stepContent_r6 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", stepContent_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c6, wizardStep_r5, $index_r2));
  }
}
function WizardHeaderComponent_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementContainer(1, 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const wizardStep_r5 = ctx_r3.$implicit;
    const $index_r2 = ctx_r3.$index;
    i0.ɵɵnextContext();
    const stepContent_r6 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", stepContent_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c6, wizardStep_r5, $index_r2));
  }
}
function WizardHeaderComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WizardHeaderComponent_For_1_Conditional_0_Template, 2, 5, "button", 1)(1, WizardHeaderComponent_For_1_Conditional_1_Template, 2, 5, "div", 2);
  }
  if (rf & 2) {
    const wizardStep_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.interactive && !wizardStep_r5.interactivityDisabled ? 0 : 1);
  }
}
function WizardHeaderComponent_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 5);
  }
}
function WizardHeaderComponent_ng_template_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8)(1, "span", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const index_r7 = i0.ɵɵnextContext().index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("current-step", index_r7 === ctx_r2.currentIndex);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(index_r7 + 1);
  }
}
function WizardHeaderComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WizardHeaderComponent_ng_template_2_Conditional_0_Template, 1, 0, "fly-icon", 5)(1, WizardHeaderComponent_ng_template_2_Conditional_1_Template, 3, 3, "span", 6);
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const wizardStep_r8 = ctx.wizardStep;
    const index_r7 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(index_r7 < ctx_r2.currentIndex || index_r7 > ctx_r2.currentIndex && wizardStep_r8.state === ctx_r2.WizardState.COMPLETE ? 0 : 1);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("complete-step", index_r7 < ctx_r2.currentIndex || index_r7 > ctx_r2.currentIndex && wizardStep_r8.state === ctx_r2.WizardState.COMPLETE)("incomplete-step-text", index_r7 === ctx_r2.currentIndex || index_r7 > ctx_r2.currentIndex && wizardStep_r8.state !== ctx_r2.WizardState.COMPLETE);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", wizardStep_r8.text, " ");
  }
}
function PageControlsComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 4);
    i0.ɵɵlistener("click", function PageControlsComponent_Conditional_3_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showAllToggle());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.hideControls ? "Hide" : "Show", " Full List ");
  }
}
function PageControlsComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-pagination", 5);
    i0.ɵɵlistener("g-page-changed", function PageControlsComponent_Conditional_4_Template_g_pagination_g_page_changed_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPageChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("currentPage", ctx_r1.currentPage())("totalPages", ctx_r1.totalPages());
  }
}
const _c7 = (a0, a1, a2, a3, a4) => ({
  success: a0,
  info: a1,
  caution: a2,
  error: a3,
  dismiss: a4
});
const _c8 = (a0, a1, a2, a3) => ({
  success: a0,
  info: a1,
  caution: a2,
  error: a3
});
function ToastComponent_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 4);
  }
}
function ToastComponent_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 5);
  }
}
function ToastComponent_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 6);
  }
}
function ToastComponent_Case_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 7);
  }
}
function ProductOptionSeriesComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "img", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("alt", ctx_r0.series().region.name);
    i0.ɵɵproperty("src", ctx_r0.imageUrl(), i0.ɵɵsanitizeUrl);
  }
}
function ProductOptionSeriesComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.series().region.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" by ", ctx_r0.series().region.vendorName, " ");
  }
}
function ProductOptionSeriesComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.series().region.name);
  }
}
function ProductOptionSeriesComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 5);
  }
}
function ProductOptionSeriesComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 6);
  }
}
function ProductOptionSeriesComponent_Conditional_10_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.series().region.coverageDescriptionHTML, i0.ɵɵsanitizeHtml);
  }
}
function ProductOptionSeriesComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "img", 9);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, ProductOptionSeriesComponent_Conditional_10_Conditional_4_Template, 1, 1, "div", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("alt", ctx_r0.series().region.name);
    i0.ɵɵproperty("src", ctx_r0.imageUrl(), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" Part Number: ", ctx_r0.partKey(), " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.series().region.coverageDescriptionHTML != null ? 4 : -1);
  }
}
const _forTrack0 = ($index, $item) => $item.id;
function ProductOptionComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "fly-product-option-series", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const series_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("partKey", ctx_r1.product.partKey)("series", series_r1);
  }
}
function BreadcrumbsComponent_For_2_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("routerLink", breadcrumb_r1.link);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", breadcrumb_r1.text, " ");
  }
}
function BreadcrumbsComponent_For_2_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("href", breadcrumb_r1.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", breadcrumb_r1.text, " ");
  }
}
function BreadcrumbsComponent_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BreadcrumbsComponent_For_2_Conditional_0_Conditional_0_Template, 2, 2, "a", 1)(1, BreadcrumbsComponent_For_2_Conditional_0_Conditional_1_Template, 2, 2, "a", 2);
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional(breadcrumb_r1.useRouterLink === true ? 0 : 1);
  }
}
function BreadcrumbsComponent_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(breadcrumb_r1.text);
  }
}
function BreadcrumbsComponent_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "/");
    i0.ɵɵelementEnd();
  }
}
function BreadcrumbsComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BreadcrumbsComponent_For_2_Conditional_0_Template, 2, 1)(1, BreadcrumbsComponent_For_2_Conditional_1_Template, 2, 1, "span")(2, BreadcrumbsComponent_For_2_Conditional_2_Template, 2, 0, "span");
  }
  if (rf & 2) {
    const breadcrumb_r1 = ctx.$implicit;
    const ɵ$index_3_r2 = ctx.$index;
    const ɵ$count_3_r3 = ctx.$count;
    i0.ɵɵconditional(breadcrumb_r1.link != null ? 0 : 1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!(ɵ$index_3_r2 === ɵ$count_3_r3 - 1) ? 2 : -1);
  }
}
const _c9 = a0 => ({
  text: "Leave",
  action: a0
});
const _c10 = a0 => ({
  text: "Cancel",
  action: a0,
  primary: true
});
const _c11 = (a0, a1) => [a0, a1];
const proxyInputs = (Cmp, inputs) => {
  const Prototype = Cmp.prototype;
  inputs.forEach(item => {
    Object.defineProperty(Prototype, item, {
      get() {
        return this.el[item];
      },
      set(val) {
        this.z.runOutsideAngular(() => this.el[item] = val);
      },
      /**
       * In the event that proxyInputs is called
       * multiple times re-defining these inputs
       * will cause an error to be thrown. As a result
       * we set configurable: true to indicate these
       * properties can be changed.
       */
      configurable: true
    });
  });
};
const proxyMethods = (Cmp, methods) => {
  const Prototype = Cmp.prototype;
  methods.forEach(methodName => {
    Prototype[methodName] = function () {
      const args = arguments;
      return this.z.runOutsideAngular(() => this.el[methodName].apply(this.el, args));
    };
  });
};
const proxyOutputs = (instance, el, events) => {
  events.forEach(eventName => instance[eventName] = fromEvent(el, eventName));
};
const defineCustomElement = (tagName, customElement) => {
  if (customElement !== undefined && typeof customElements !== 'undefined' && !customElements.get(tagName)) {
    customElements.define(tagName, customElement);
  }
};
// tslint:disable-next-line: only-arrow-functions
function ProxyCmp(opts) {
  const decorator = function (cls) {
    const {
      defineCustomElementFn,
      inputs,
      methods
    } = opts;
    if (defineCustomElementFn !== undefined) {
      defineCustomElementFn();
    }
    if (inputs) {
      proxyInputs(cls, inputs);
    }
    if (methods) {
      proxyMethods(cls, methods);
    }
    return cls;
  };
  return decorator;
}
let GAccordion = class GAccordion {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GAccordion_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GAccordion)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GAccordion,
      selectors: [["g-accordion"]],
      inputs: {
        dataTestId: "dataTestId",
        dropShadow: "dropShadow",
        expanded: "expanded",
        heading: "heading",
        theme: "theme"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GAccordion_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GAccordion = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'dropShadow', 'expanded', 'heading', 'theme']
})], GAccordion);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GAlert = class GAlert {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['g-close']);
  }
  static {
    this.ɵfac = function GAlert_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GAlert)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GAlert,
      selectors: [["g-alert"]],
      inputs: {
        closeBtnLabel: "closeBtnLabel",
        closeable: "closeable",
        dataTestId: "dataTestId",
        leftIcon: "leftIcon",
        show: "show",
        slotAlign: "slotAlign",
        styleObject: "styleObject",
        type: "type"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GAlert_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GAlert = __decorate([ProxyCmp({
  inputs: ['closeBtnLabel', 'closeable', 'dataTestId', 'leftIcon', 'show', 'slotAlign', 'styleObject', 'type']
})], GAlert);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GBanner = class GBanner {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GBanner_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GBanner)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GBanner,
      selectors: [["g-banner"]],
      inputs: {
        banner: "banner",
        clickCallback: "clickCallback",
        contentAlignment: "contentAlignment",
        contentColor: "contentColor",
        contentTheme: "contentTheme",
        dataTestId: "dataTestId",
        gradient: "gradient"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GBanner_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GBanner = __decorate([ProxyCmp({
  inputs: ['banner', 'clickCallback', 'contentAlignment', 'contentColor', 'contentTheme', 'dataTestId', 'gradient']
})], GBanner);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GBreadcrumb = class GBreadcrumb {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GBreadcrumb_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GBreadcrumb)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GBreadcrumb,
      selectors: [["g-breadcrumb"]],
      inputs: {
        dataTestId: "dataTestId",
        links: "links",
        text: "text",
        url: "url"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GBreadcrumb_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GBreadcrumb = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'links', 'text', 'url']
})], GBreadcrumb);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GBreadcrumbs = class GBreadcrumbs {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GBreadcrumbs_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GBreadcrumbs)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GBreadcrumbs,
      selectors: [["g-breadcrumbs"]],
      inputs: {
        breadcrumbs: "breadcrumbs",
        label: "label",
        stackMobile: "stackMobile"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GBreadcrumbs_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GBreadcrumbs = __decorate([ProxyCmp({
  inputs: ['breadcrumbs', 'label', 'stackMobile']
})], GBreadcrumbs);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GBrowserAlert = class GBrowserAlert {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GBrowserAlert_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GBrowserAlert)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GBrowserAlert,
      selectors: [["g-browser-alert"]],
      inputs: {
        browserConfig: "browserConfig",
        dataTestId: "dataTestId"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GBrowserAlert_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GBrowserAlert = __decorate([ProxyCmp({
  inputs: ['browserConfig', 'dataTestId']
})], GBrowserAlert);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GButton = class GButton {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['g-blur', 'g-focus']);
  }
  static {
    this.ɵfac = function GButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GButton,
      selectors: [["g-button"]],
      inputs: {
        chevron: "chevron",
        dataTestId: "dataTestId",
        disabled: "disabled",
        flat: "flat",
        flatTheme: "flatTheme",
        href: "href",
        isCurrent: "isCurrent",
        label: "label",
        noHover: "noHover",
        size: "size",
        styleObject: "styleObject",
        target: "target",
        theme: "theme",
        type: "type"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GButton = __decorate([ProxyCmp({
  inputs: ['chevron', 'dataTestId', 'disabled', 'flat', 'flatTheme', 'href', 'isCurrent', 'label', 'noHover', 'size', 'styleObject', 'target', 'theme', 'type'],
  methods: ['setFocus', 'removeFocus']
})], GButton);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GButtonContainer = class GButtonContainer {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GButtonContainer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GButtonContainer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GButtonContainer,
      selectors: [["g-button-container"]],
      inputs: {
        alignment: "alignment",
        dataTestId: "dataTestId",
        direction: "direction",
        theme: "theme"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GButtonContainer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GButtonContainer = __decorate([ProxyCmp({
  inputs: ['alignment', 'dataTestId', 'direction', 'theme']
})], GButtonContainer);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GButtonGroup = class GButtonGroup {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GButtonGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GButtonGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GButtonGroup,
      selectors: [["g-button-group"]],
      inputs: {
        buttons: "buttons",
        dataTestId: "dataTestId",
        label: "label"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GButtonGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GButtonGroup = __decorate([ProxyCmp({
  inputs: ['buttons', 'dataTestId', 'label']
})], GButtonGroup);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GCard = class GCard {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GCard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GCard)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GCard,
      selectors: [["g-card"]],
      inputs: {
        card: "card",
        cardDirection: "cardDirection",
        dataTestId: "dataTestId",
        imageOnly: "imageOnly",
        theme: "theme",
        width: "width"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GCard_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GCard = __decorate([ProxyCmp({
  inputs: ['card', 'cardDirection', 'dataTestId', 'imageOnly', 'theme', 'width']
})], GCard);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GCardContainer = class GCardContainer {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GCardContainer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GCardContainer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GCardContainer,
      selectors: [["g-card-container"]],
      inputs: {
        cardDirection: "cardDirection",
        cards: "cards",
        dataTestId: "dataTestId",
        imageOnly: "imageOnly",
        styleObject: "styleObject",
        theme: "theme",
        width: "width"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GCardContainer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GCardContainer = __decorate([ProxyCmp({
  inputs: ['cardDirection', 'cards', 'dataTestId', 'imageOnly', 'styleObject', 'theme', 'width']
})], GCardContainer);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GCheckbox = class GCheckbox {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GCheckbox_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GCheckbox)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GCheckbox,
      selectors: [["g-checkbox"]],
      inputs: {
        dataTestId: "dataTestId",
        indeterminate: "indeterminate",
        label: "label"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GCheckbox_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GCheckbox = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'indeterminate', 'label']
})], GCheckbox);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GChip = class GChip {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GChip_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GChip)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GChip,
      selectors: [["g-chip"]],
      inputs: {
        dataTestId: "dataTestId",
        fill: "fill",
        label: "label",
        leadingIconSlot: "leadingIconSlot",
        theme: "theme",
        trailingIconSlot: "trailingIconSlot"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GChip_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GChip = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'fill', 'label', 'leadingIconSlot', 'theme', 'trailingIconSlot']
})], GChip);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GCollapsibleRegion = class GCollapsibleRegion {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['g-collapse', 'g-expand']);
  }
  static {
    this.ɵfac = function GCollapsibleRegion_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GCollapsibleRegion)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GCollapsibleRegion,
      selectors: [["g-collapsible-region"]],
      inputs: {
        dataTestId: "dataTestId",
        expanded: "expanded"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GCollapsibleRegion_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GCollapsibleRegion = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'expanded']
})], GCollapsibleRegion);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GColorSwatches = class GColorSwatches {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GColorSwatches_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GColorSwatches)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GColorSwatches,
      selectors: [["g-color-swatches"]],
      inputs: {
        dataTestId: "dataTestId",
        maxNumber: "maxNumber",
        swatches: "swatches"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GColorSwatches_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GColorSwatches = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'maxNumber', 'swatches']
})], GColorSwatches);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GCopy = class GCopy {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GCopy_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GCopy)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GCopy,
      selectors: [["g-copy"]],
      inputs: {
        dataTestId: "dataTestId",
        linkColor: "linkColor",
        styleObject: "styleObject",
        textAlign: "textAlign",
        theme: "theme",
        type: "type"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GCopy_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GCopy = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'linkColor', 'styleObject', 'textAlign', 'theme', 'type']
})], GCopy);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GDropDown = class GDropDown {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GDropDown_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GDropDown)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GDropDown,
      selectors: [["g-drop-down"]],
      inputs: {
        dataTestId: "dataTestId",
        error: "error",
        hideLabel: "hideLabel",
        label: "label",
        required: "required"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GDropDown_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GDropDown = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'error', 'hideLabel', 'label', 'required']
})], GDropDown);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GError = class GError {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GError_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GError)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GError,
      selectors: [["g-error"]],
      inputs: {
        dataTestId: "dataTestId"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GError_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GError = __decorate([ProxyCmp({
  inputs: ['dataTestId']
})], GError);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GFlex = class GFlex {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GFlex_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GFlex)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GFlex,
      selectors: [["g-flex"]],
      inputs: {
        alignContent: "alignContent",
        alignItems: "alignItems",
        alignSelf: "alignSelf",
        dataTestId: "dataTestId",
        display: "display",
        flex: "flex",
        flexBasis: "flexBasis",
        flexDirection: "flexDirection",
        flexGrow: "flexGrow",
        flexShrink: "flexShrink",
        flexWrap: "flexWrap",
        height: "height",
        justifyContent: "justifyContent",
        margin: "margin",
        marginBottom: "marginBottom",
        marginLeft: "marginLeft",
        marginRight: "marginRight",
        marginTop: "marginTop",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        order: "order",
        padding: "padding",
        paddingBottom: "paddingBottom",
        paddingLeft: "paddingLeft",
        paddingRight: "paddingRight",
        paddingTop: "paddingTop",
        width: "width"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GFlex_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GFlex = __decorate([ProxyCmp({
  inputs: ['alignContent', 'alignItems', 'alignSelf', 'dataTestId', 'display', 'flex', 'flexBasis', 'flexDirection', 'flexGrow', 'flexShrink', 'flexWrap', 'height', 'justifyContent', 'margin', 'marginBottom', 'marginLeft', 'marginRight', 'marginTop', 'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'order', 'padding', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop', 'width']
})], GFlex);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GFullImage = class GFullImage {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GFullImage_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GFullImage)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GFullImage,
      selectors: [["g-full-image"]],
      inputs: {
        dataTestId: "dataTestId",
        ignoreMaxHeight: "ignoreMaxHeight",
        imageAltText: "imageAltText",
        imageLargeUrl: "imageLargeUrl",
        imageMediumUrl: "imageMediumUrl",
        imageSmallUrl: "imageSmallUrl"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GFullImage_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GFullImage = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'ignoreMaxHeight', 'imageAltText', 'imageLargeUrl', 'imageMediumUrl', 'imageSmallUrl']
})], GFullImage);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GGlobalStyles = class GGlobalStyles {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GGlobalStyles_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GGlobalStyles)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GGlobalStyles,
      selectors: [["g-global-styles"]],
      inputs: {
        dataTestId: "dataTestId"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GGlobalStyles_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GGlobalStyles = __decorate([ProxyCmp({
  inputs: ['dataTestId']
})], GGlobalStyles);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GHeading = class GHeading {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GHeading_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GHeading)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GHeading,
      selectors: [["g-heading"]],
      inputs: {
        caseTransform: "caseTransform",
        content: "content",
        dataTestId: "dataTestId",
        size: "size",
        styleObject: "styleObject",
        textAlign: "textAlign",
        theme: "theme"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GHeading_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GHeading = __decorate([ProxyCmp({
  inputs: ['caseTransform', 'content', 'dataTestId', 'size', 'styleObject', 'textAlign', 'theme']
})], GHeading);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GHelpText = class GHelpText {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GHelpText_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GHelpText)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GHelpText,
      selectors: [["g-help-text"]],
      inputs: {
        dataTestId: "dataTestId"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GHelpText_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GHelpText = __decorate([ProxyCmp({
  inputs: ['dataTestId']
})], GHelpText);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GHeroRotator = class GHeroRotator {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GHeroRotator_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GHeroRotator)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GHeroRotator,
      selectors: [["g-hero-rotator"]],
      inputs: {
        clickCallback: "clickCallback",
        content: "content",
        dataTestId: "dataTestId",
        nextSlideText: "nextSlideText",
        playPauseText: "playPauseText",
        previousSlideText: "previousSlideText",
        slideshowControlText: "slideshowControlText"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GHeroRotator_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GHeroRotator = __decorate([ProxyCmp({
  inputs: ['clickCallback', 'content', 'dataTestId', 'nextSlideText', 'playPauseText', 'previousSlideText', 'slideshowControlText']
})], GHeroRotator);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GHorizontalLayout = class GHorizontalLayout {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GHorizontalLayout_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GHorizontalLayout)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GHorizontalLayout,
      selectors: [["g-horizontal-layout"]],
      inputs: {
        dataTestId: "dataTestId",
        reverseRow: "reverseRow"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GHorizontalLayout_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GHorizontalLayout = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'reverseRow']
})], GHorizontalLayout);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GInput = class GInput {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['g-open', 'g-close', 'g-click-append', 'g-click-floating-label', 'g-valid', 'g-invalid']);
  }
  static {
    this.ɵfac = function GInput_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GInput)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GInput,
      selectors: [["g-input"]],
      inputs: {
        buttonTheme: "buttonTheme",
        buttonTitle: "buttonTitle",
        dataTestId: "dataTestId",
        error: "error",
        floatingLabel: "floatingLabel",
        floatingLabelState: "floatingLabelState",
        hideLabel: "hideLabel",
        label: "label",
        labelFor: "labelFor",
        pattern: "pattern",
        required: "required",
        tooltip: "tooltip",
        tooltipOpen: "tooltipOpen",
        type: "type",
        withButton: "withButton"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GInput_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GInput = __decorate([ProxyCmp({
  inputs: ['buttonTheme', 'buttonTitle', 'dataTestId', 'error', 'floatingLabel', 'floatingLabelState', 'hideLabel', 'label', 'labelFor', 'pattern', 'required', 'tooltip', 'tooltipOpen', 'type', 'withButton']
})], GInput);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GKicker = class GKicker {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GKicker_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GKicker)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GKicker,
      selectors: [["g-kicker"]],
      inputs: {
        additionalText: "additionalText",
        altColor: "altColor",
        containerAriaLabel: "containerAriaLabel",
        dataTestId: "dataTestId",
        kickerColor: "kickerColor",
        kickerShape: "kickerShape",
        text: "text"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GKicker_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GKicker = __decorate([ProxyCmp({
  inputs: ['additionalText', 'altColor', 'containerAriaLabel', 'dataTestId', 'kickerColor', 'kickerShape', 'text']
})], GKicker);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GListTable = class GListTable {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GListTable_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GListTable)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GListTable,
      selectors: [["g-list-table"]],
      inputs: {
        dataTestId: "dataTestId",
        listTableHeadings: "listTableHeadings",
        listTableRows: "listTableRows"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GListTable_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GListTable = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'listTableHeadings', 'listTableRows']
})], GListTable);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GLoader = class GLoader {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GLoader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GLoader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GLoader,
      selectors: [["g-loader"]],
      inputs: {
        dataTestId: "dataTestId",
        styleObject: "styleObject",
        type: "type"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GLoader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GLoader = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'styleObject', 'type']
})], GLoader);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GPagination = class GPagination {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['g-page-changed']);
  }
  static {
    this.ɵfac = function GPagination_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GPagination)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GPagination,
      selectors: [["g-pagination"]],
      inputs: {
        currentPage: "currentPage",
        dataTestId: "dataTestId",
        ellipses: "ellipses",
        firstButtonLabel: "firstButtonLabel",
        firstLastPageButtons: "firstLastPageButtons",
        lastButtonLabel: "lastButtonLabel",
        maxVisibleButtons: "maxVisibleButtons",
        nextButtonLabel: "nextButtonLabel",
        pageButtonLabel: "pageButtonLabel",
        paginationLabel: "paginationLabel",
        previousButtonLabel: "previousButtonLabel",
        theme: "theme",
        totalPages: "totalPages"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GPagination_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GPagination = __decorate([ProxyCmp({
  inputs: ['currentPage', 'dataTestId', 'ellipses', 'firstButtonLabel', 'firstLastPageButtons', 'lastButtonLabel', 'maxVisibleButtons', 'nextButtonLabel', 'pageButtonLabel', 'paginationLabel', 'previousButtonLabel', 'theme', 'totalPages']
})], GPagination);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GPhotoGrid = class GPhotoGrid {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GPhotoGrid_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GPhotoGrid)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GPhotoGrid,
      selectors: [["g-photo-grid"]],
      inputs: {
        dataTestId: "dataTestId",
        imageAltText: "imageAltText",
        imageUrl: "imageUrl",
        linkText: "linkText",
        linkUrl: "linkUrl"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GPhotoGrid_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GPhotoGrid = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'imageAltText', 'imageUrl', 'linkText', 'linkUrl']
})], GPhotoGrid);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GPrice = class GPrice {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GPrice_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GPrice)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GPrice,
      selectors: [["g-price"]],
      inputs: {
        andUpText: "andUpText",
        blueDiscountFont: "blueDiscountFont",
        dataTestId: "dataTestId",
        detailsText: "detailsText",
        discountedPrice: "discountedPrice",
        fromText: "fromText",
        hasText: "hasText",
        originalPrice: "originalPrice",
        savingsText: "savingsText",
        variant: "variant"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GPrice_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GPrice = __decorate([ProxyCmp({
  inputs: ['andUpText', 'blueDiscountFont', 'dataTestId', 'detailsText', 'discountedPrice', 'fromText', 'hasText', 'originalPrice', 'savingsText', 'variant']
})], GPrice);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GRadio = class GRadio {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GRadio_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GRadio)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GRadio,
      selectors: [["g-radio"]],
      inputs: {
        dataTestId: "dataTestId",
        label: "label"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GRadio_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GRadio = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'label']
})], GRadio);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GShowMore = class GShowMore {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GShowMore_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GShowMore)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GShowMore,
      selectors: [["g-show-more"]],
      inputs: {
        dataTestId: "dataTestId",
        text: "text"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GShowMore_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GShowMore = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'text']
})], GShowMore);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GSkeleton = class GSkeleton {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GSkeleton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GSkeleton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GSkeleton,
      selectors: [["g-skeleton"]],
      inputs: {
        dataTestId: "dataTestId"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GSkeleton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GSkeleton = __decorate([ProxyCmp({
  inputs: ['dataTestId']
})], GSkeleton);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GSpacer = class GSpacer {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GSpacer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GSpacer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GSpacer,
      selectors: [["g-spacer"]],
      inputs: {
        color: "color",
        dataTestId: "dataTestId",
        divider: "divider",
        dividerColor: "dividerColor",
        height: "height"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GSpacer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GSpacer = __decorate([ProxyCmp({
  inputs: ['color', 'dataTestId', 'divider', 'dividerColor', 'height']
})], GSpacer);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GSpotlight = class GSpotlight {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GSpotlight_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GSpotlight)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GSpotlight,
      selectors: [["g-spotlight"]],
      inputs: {
        copy: "copy",
        ctas: "ctas",
        dataTestId: "dataTestId",
        heading: "heading",
        imgAltText: "imgAltText",
        imgSrc: "imgSrc",
        mediaAlignment: "mediaAlignment",
        theme: "theme",
        type: "type"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GSpotlight_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GSpotlight = __decorate([ProxyCmp({
  inputs: ['copy', 'ctas', 'dataTestId', 'heading', 'imgAltText', 'imgSrc', 'mediaAlignment', 'theme', 'type']
})], GSpotlight);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GStepper = class GStepper {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GStepper_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GStepper)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GStepper,
      selectors: [["g-stepper"]],
      inputs: {
        dataTestId: "dataTestId",
        steps: "steps"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GStepper_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GStepper = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'steps']
})], GStepper);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GSubNav = class GSubNav {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GSubNav_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GSubNav)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GSubNav,
      selectors: [["g-sub-nav"]],
      inputs: {
        backgroundColor: "backgroundColor",
        blueActiveLink: "blueActiveLink",
        colorize: "colorize",
        dataTestId: "dataTestId",
        links: "links",
        type: "type"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GSubNav_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GSubNav = __decorate([ProxyCmp({
  inputs: ['backgroundColor', 'blueActiveLink', 'colorize', 'dataTestId', 'links', 'type']
})], GSubNav);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GSwitch = class GSwitch {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GSwitch_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GSwitch)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GSwitch,
      selectors: [["g-switch"]],
      inputs: {
        dataTestId: "dataTestId",
        emphasizeLabels: "emphasizeLabels",
        hideLabels: "hideLabels",
        leftLabel: "leftLabel",
        rightLabel: "rightLabel",
        size: "size"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GSwitch_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GSwitch = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'emphasizeLabels', 'hideLabels', 'leftLabel', 'rightLabel', 'size']
})], GSwitch);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GTextarea = class GTextarea {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GTextarea_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GTextarea)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GTextarea,
      selectors: [["g-textarea"]],
      inputs: {
        dataTestId: "dataTestId",
        error: "error",
        hideLabel: "hideLabel",
        label: "label",
        required: "required"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GTextarea_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GTextarea = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'error', 'hideLabel', 'label', 'required']
})], GTextarea);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GTile = class GTile {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GTile_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GTile)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GTile,
      selectors: [["g-tile"]],
      inputs: {
        buttonAlignment: "buttonAlignment",
        buttonPositioning: "buttonPositioning",
        dataTestId: "dataTestId",
        gradient: "gradient",
        hasCtaBorder: "hasCtaBorder",
        height: "height",
        horizontalTextAlignment: "horizontalTextAlignment",
        target: "target",
        theme: "theme",
        tileContent: "tileContent",
        verticalTextAlignment: "verticalTextAlignment",
        width: "width"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GTile_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GTile = __decorate([ProxyCmp({
  inputs: ['buttonAlignment', 'buttonPositioning', 'dataTestId', 'gradient', 'hasCtaBorder', 'height', 'horizontalTextAlignment', 'target', 'theme', 'tileContent', 'verticalTextAlignment', 'width']
})], GTile);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GTooltip = class GTooltip {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['g-open', 'g-close']);
  }
  static {
    this.ɵfac = function GTooltip_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GTooltip)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GTooltip,
      selectors: [["g-tooltip"]],
      inputs: {
        dataTestId: "dataTestId",
        tooltipText: "tooltipText",
        tooltipTitle: "tooltipTitle"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GTooltip_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GTooltip = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'tooltipText', 'tooltipTitle'],
  methods: ['toggleTooltip']
})], GTooltip);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GVerticalNav = class GVerticalNav {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['g-click']);
  }
  static {
    this.ɵfac = function GVerticalNav_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GVerticalNav)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GVerticalNav,
      selectors: [["g-vertical-nav"]],
      inputs: {
        dataTestId: "dataTestId",
        fill: "fill",
        mobileHeading: "mobileHeading",
        navContent: "navContent",
        sideNavPosition: "sideNavPosition",
        styleObject: "styleObject"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GVerticalNav_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GVerticalNav = __decorate([ProxyCmp({
  inputs: ['dataTestId', 'fill', 'mobileHeading', 'navContent', 'sideNavPosition', 'styleObject']
})], GVerticalNav);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GVideoBanner = class GVideoBanner {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GVideoBanner_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GVideoBanner)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GVideoBanner,
      selectors: [["g-video-banner"]],
      inputs: {
        autoplay: "autoplay",
        captions: "captions",
        captionsLang: "captionsLang",
        controls: "controls",
        copy: "copy",
        copyPosition: "copyPosition",
        dataTestId: "dataTestId",
        heading: "heading",
        headingPosition: "headingPosition",
        image: "image",
        loop: "loop",
        mediaTitle: "mediaTitle",
        muted: "muted",
        playButtonColor: "playButtonColor",
        playButtonText: "playButtonText",
        playsinline: "playsinline",
        preload: "preload",
        renderFormat: "renderFormat",
        singleVideo: "singleVideo",
        source: "source",
        styleObject: "styleObject"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GVideoBanner_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GVideoBanner = __decorate([ProxyCmp({
  inputs: ['autoplay', 'captions', 'captionsLang', 'controls', 'copy', 'copyPosition', 'dataTestId', 'heading', 'headingPosition', 'image', 'loop', 'mediaTitle', 'muted', 'playButtonColor', 'playButtonText', 'playsinline', 'preload', 'renderFormat', 'singleVideo', 'source', 'styleObject']
})], GVideoBanner);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GVideoContainer = class GVideoContainer {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function GVideoContainer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GVideoContainer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GVideoContainer,
      selectors: [["g-video-container"]],
      inputs: {
        containerCopy: "containerCopy",
        containerHeading: "containerHeading",
        content: "content",
        dataTestId: "dataTestId",
        theme: "theme",
        width: "width"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function GVideoContainer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
GVideoContainer = __decorate([ProxyCmp({
  inputs: ['containerCopy', 'containerHeading', 'content', 'dataTestId', 'theme', 'width']
})], GVideoContainer);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiSelectButtonGroupDemo = class MultiSelectButtonGroupDemo {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function MultiSelectButtonGroupDemo_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiSelectButtonGroupDemo)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MultiSelectButtonGroupDemo,
      selectors: [["multi-select-button-group-demo"]],
      inputs: {
        label: "label"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function MultiSelectButtonGroupDemo_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
MultiSelectButtonGroupDemo = __decorate([ProxyCmp({
  inputs: ['label']
})], MultiSelectButtonGroupDemo);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PaginationDemo = class PaginationDemo {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function PaginationDemo_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaginationDemo)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PaginationDemo,
      selectors: [["pagination-demo"]],
      inputs: {
        theme: "theme"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function PaginationDemo_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
PaginationDemo = __decorate([ProxyCmp({
  inputs: ['theme']
})], PaginationDemo);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SingleSelectButtonGroupDemo = class SingleSelectButtonGroupDemo {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
  static {
    this.ɵfac = function SingleSelectButtonGroupDemo_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SingleSelectButtonGroupDemo)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SingleSelectButtonGroupDemo,
      selectors: [["single-select-button-group-demo"]],
      inputs: {
        label: "label"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SingleSelectButtonGroupDemo_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
};
SingleSelectButtonGroupDemo = __decorate([ProxyCmp({
  inputs: ['label']
})], SingleSelectButtonGroupDemo);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ComponentsGlobalWebModule = /*#__PURE__*/(() => {
  class ComponentsGlobalWebModule {
    static {
      this.ɵfac = function ComponentsGlobalWebModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ComponentsGlobalWebModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ComponentsGlobalWebModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return ComponentsGlobalWebModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DIRECTIVES = [GAccordion, GAlert, GBanner, GBreadcrumb, GBreadcrumbs, GBrowserAlert, GButton, GButtonContainer, GButtonGroup, GCard, GCardContainer, GCheckbox, GChip, GCollapsibleRegion, GColorSwatches, GCopy, GDropDown, GError, GFlex, GFullImage, GGlobalStyles, GHeading, GHelpText, GHeroRotator, GHorizontalLayout, GInput, GKicker, GListTable, GLoader, GPagination, GPhotoGrid, GPrice, GRadio, GShowMore, GSkeleton, GSpacer, GSpotlight, GStepper, GSubNav, GSwitch, GTextarea, GTile, GTooltip, GVerticalNav, GVideoBanner, GVideoContainer, MultiSelectButtonGroupDemo, PaginationDemo, SingleSelectButtonGroupDemo];
let AutoCompleteInputComponent = /*#__PURE__*/(() => {
  class AutoCompleteInputComponent {
    constructor() {
      this.placeholder = '';
      this.destroyRef = inject(DestroyRef);
      this.injector = inject(Injector);
      this.inputId = generateUniqueId();
      this.listId = generateUniqueId();
      this.internalFormControl = new FormControl('', {
        nonNullable: true
      });
      this.filteredOptions = signal([]);
      this.showOptions = signal(false);
      this.required = false;
    }
    ngOnInit() {
      const ngControl = this.injector.get(NgControl);
      if (ngControl instanceof FormControlName) {
        this.externalFormControl = this.injector.get(FormGroupDirective).getControl(ngControl);
      } else {
        this.externalFormControl = ngControl.form;
      }
      /*
        Skip the first emission since writeValue is called with the form control's initial value already.
        We only want to listen for changes that happen after that.
      */
      this.internalFormControl.valueChanges.pipe(skip(1), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.filterOptionsByTextInputValue();
        if (this.filteredOptions().length > 0) {
          this.showOptions.set(true);
        }
      });
      this.required = this.externalFormControl.hasValidator(Validators.required);
      this.externalFormControl.statusChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.required = this.externalFormControl.hasValidator(Validators.required);
      });
    }
    handleOptionSelected(selectedOption) {
      this.showOptions.set(false);
      this.onChange(selectedOption.value);
      // Do not emit the event since that would re-open the list of filtered options.
      this.internalFormControl.setValue(selectedOption.displayText, {
        emitEvent: false
      });
      this.filterOptionsByTextInputValue();
    }
    handleFocus() {
      if (this.internalFormControl.value.length > 0) {
        this.showOptions.set(true);
      }
    }
    handleFocusOut(event) {
      /*
        Manually set the external form control to dirty if the internal form control is dirty since the
        value of the external form control will be unchanged if the user only enters invalid values.
      */
      if (this.internalFormControl.dirty) {
        this.externalFormControl.markAsDirty();
      }
      this.onTouched();
      const gInput = event.currentTarget;
      const focusedElement = event.relatedTarget;
      if (gInput.contains(focusedElement)) {
        event.stopPropagation();
      } else {
        this.showOptions.set(false);
        /*
          If the user leaves the input without actually selecting an option, but the value they entered
          exactly matches an option, select that option for them. Conversely, if they previously selected
          an option and have since entered an invalid value, unselect the previously selected option.
        */
        const exactMatch = this.options.find(option => {
          return this.standardizeString(option.displayText) === this.standardizeString(this.internalFormControl.value);
        });
        if (exactMatch != null && exactMatch.value !== this.externalFormControl.value) {
          this.onChange(exactMatch.value);
        } else if (exactMatch == null && this.externalFormControl.value != null) {
          this.onChange(null);
        }
      }
    }
    focusNextOption(event, index) {
      event.preventDefault();
      if (index < this.optionRefs.length - 1) {
        this.optionRefs.get(index + 1)?.nativeElement.focus();
      }
    }
    focusPreviousOption(event, index) {
      event.preventDefault();
      if (index > 0) {
        this.optionRefs.get(index - 1)?.nativeElement.focus();
      }
    }
    focusFirstOption(event) {
      event.preventDefault();
      this.optionRefs.get(0)?.nativeElement.focus();
    }
    focusLastOption(event) {
      event.preventDefault();
      this.optionRefs.get(this.optionRefs.length - 1)?.nativeElement.focus();
    }
    writeValue(value) {
      const matchingOption = this.options.find(option => option.value === value);
      if (value != null && matchingOption == null) {
        console.warn('The value set for the auto-complete input does not match any of the options provided.');
      }
      const displayText = matchingOption?.displayText ?? '';
      this.internalFormControl.setValue(displayText, {
        emitEvent: false
      });
      this.filterOptionsByTextInputValue();
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      if (isDisabled) {
        this.internalFormControl.disable();
      } else {
        this.internalFormControl.enable();
      }
    }
    // Removes whitespace, removes hyphens, and converts to lowercase
    standardizeString(originalString) {
      return originalString.replace(/[-\s]/g, '').toLowerCase();
    }
    filterOptionsByTextInputValue() {
      // Retrieve all words in the input
      const searchWords = this.internalFormControl.value.trim().toLowerCase().split(/\s+/);
      this.filteredOptions.set(searchWords.length ? this.options.filter(({
        displayText
      }) =>
      // Search for each word in the input
      searchWords.every(word => this.standardizeString(displayText).includes(word))) : []);
    }
    static {
      this.ɵfac = function AutoCompleteInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AutoCompleteInputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AutoCompleteInputComponent,
        selectors: [["fly-auto-complete-input"]],
        viewQuery: function AutoCompleteInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionRefs = _t);
          }
        },
        inputs: {
          label: "label",
          options: "options",
          gErrorId: "gErrorId",
          placeholder: "placeholder"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          multi: true,
          useExisting: AutoCompleteInputComponent
        }])],
        decls: 3,
        vars: 11,
        consts: [["option", ""], [1, "g-input", 3, "focusout", "label", "error"], ["type", "text", "role", "combobox", "aria-autocomplete", "both", "aria-haspopup", "listbox", "aria-multiline", "false", 3, "focus", "keydown.arrowdown", "keydown.home", "keydown.end", "id", "placeholder", "formControl"], ["role", "listbox", 1, "options-list", 3, "id", "non-empty"], ["role", "listbox", 1, "options-list", 3, "id"], ["tabindex", "0", 1, "option"], ["tabindex", "0", 1, "option", 3, "click", "keydown.enter", "keydown.arrowdown", "keydown.arrowup", "keydown.home", "keydown.end"]],
        template: function AutoCompleteInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "g-input", 1);
            i0.ɵɵlistener("focusout", function AutoCompleteInputComponent_Template_g_input_focusout_0_listener($event) {
              return ctx.handleFocusOut($event);
            });
            i0.ɵɵelementStart(1, "input", 2);
            i0.ɵɵlistener("focus", function AutoCompleteInputComponent_Template_input_focus_1_listener() {
              return ctx.handleFocus();
            })("keydown.arrowdown", function AutoCompleteInputComponent_Template_input_keydown_arrowdown_1_listener($event) {
              return ctx.focusFirstOption($event);
            })("keydown.home", function AutoCompleteInputComponent_Template_input_keydown_home_1_listener($event) {
              return ctx.focusFirstOption($event);
            })("keydown.end", function AutoCompleteInputComponent_Template_input_keydown_end_1_listener($event) {
              return ctx.focusLastOption($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, AutoCompleteInputComponent_Conditional_2_Template, 3, 4, "ul", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.label)("error", ctx.externalFormControl.errors != null && !ctx.externalFormControl.pristine);
            i0.ɵɵattribute("label-for", ctx.inputId)("required", ctx.required);
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.inputId)("placeholder", ctx.placeholder)("formControl", ctx.internalFormControl);
            i0.ɵɵattribute("aria-describedby", ctx.gErrorId)("aria-expanded", ctx.showOptions())("aria-controls", ctx.listId);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showOptions() ? 2 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, GInput, ReactiveFormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlDirective],
        styles: [".g-input[_ngcontent-%COMP%]{position:relative}.options-list[_ngcontent-%COMP%]{position:absolute;top:100%;display:flex;flex-direction:column;width:100%;max-height:15rem;overflow-y:auto;scroll-behavior:smooth;-webkit-user-select:none;user-select:none;cursor:pointer}.options-list.non-empty[_ngcontent-%COMP%]{box-shadow:0 1px 1px #4d4d4d14,0 1px 3px 1px #4d4d4d29;border:1px solid rgb(216.75,216.75,216.75)}.option[_ngcontent-%COMP%]{margin:0;background-color:#fff;padding:0 .875em}.option[_ngcontent-%COMP%]:hover{color:#fff;background-color:#106fad}"]
      });
    }
  }
  return AutoCompleteInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Fly-Icon - Component to display icons from the assets/icons directory
 *
 * @example Basic usage
 * <fly-icon
 *   icon="plus-circle"
 *   class="icon size-standard color-black">
 * </fly-icon>
 *
 * NOTE: import the icon modifier classes with this:
 * // @use '../relative/path/to/../shared/styles/icon.styles.scss';
 */
let IconComponent = /*#__PURE__*/(() => {
  class IconComponent {
    constructor() {
      this.libConfig = inject(FLY_WEB_COMMON_CONFIG);
    }
    ngOnInit() {
      this.link = `${this.libConfig.assetsPath ?? ''}assets/icons/${this.icon}.svg#${this.icon}`;
    }
    static {
      this.ɵfac = function IconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IconComponent,
        selectors: [["fly-icon"]],
        inputs: {
          icon: "icon"
        },
        decls: 2,
        vars: 1,
        consts: [["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink"]],
        template: function IconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0);
            i0.ɵɵelement(1, "use");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵattribute("href", ctx.link);
          }
        },
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:block;height:100%;width:100%}svg[_ngcontent-%COMP%]{height:100%;width:100%}"]
      });
    }
  }
  return IconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CollapsibleStepComponent = /*#__PURE__*/(() => {
  class CollapsibleStepComponent {
    constructor() {
      this.open = false;
    }
    toggle() {
      this.open = !this.open;
    }
    static {
      this.ɵfac = function CollapsibleStepComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CollapsibleStepComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CollapsibleStepComponent,
        selectors: [["fly-collapsible-step"]],
        inputs: {
          open: "open",
          stepLabel: "stepLabel"
        },
        ngContentSelectors: _c0,
        decls: 8,
        vars: 5,
        consts: [["title", "Expand or collapse this section", 3, "click"], [1, "expand-icon"], ["icon", "chevron-down"], [1, "collapsible-content"]],
        template: function CollapsibleStepComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "section")(1, "header", 0);
            i0.ɵɵlistener("click", function CollapsibleStepComponent_Template_header_click_1_listener() {
              return ctx.toggle();
            });
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵelement(3, "fly-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "h3");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 3);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("rotate", ctx.open);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.stepLabel, " ");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("open", ctx.open);
          }
        },
        dependencies: [CommonModule, IconComponent],
        styles: ["header[_ngcontent-%COMP%]{display:flex;align-items:center;gap:1.25rem;cursor:pointer}header[_ngcontent-%COMP%] > .expand-icon[_ngcontent-%COMP%]{height:1.33rem;width:1.33rem;transition:transform .2s ease}.expand-icon.rotate[_ngcontent-%COMP%]{transform:rotate(180deg)}.collapsible-content[_ngcontent-%COMP%]{display:none}@media screen and (min-width: 768px){.collapsible-content[_ngcontent-%COMP%]{padding-left:2.5rem}}.collapsible-content.open[_ngcontent-%COMP%]{display:block;animation:_ngcontent-%COMP%_drop-in-animation .2s}@keyframes _ngcontent-%COMP%_drop-in-animation{0%{transform:translateY(-10%)}to{transform:translateY(0)}}"]
      });
    }
  }
  return CollapsibleStepComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var ImageType = /*#__PURE__*/function (ImageType) {
  ImageType["GIF"] = "image/gif";
  ImageType["JPEG"] = "image/jpeg";
  ImageType["PNG"] = "image/png";
  return ImageType;
}(ImageType || {});
// These transform functions must be defined outside the class and cannot be arrow functions
function transformAllowedFileTypesInput(value) {
  return value == null || value.length === 0 ? signal(Object.values(ImageType)) : signal(value);
}
function transformMaxFileSizeMbInput(value) {
  return value == null || value <= 0 ? signal(10) : signal(value);
}
let ImageUploadComponent = /*#__PURE__*/(() => {
  class ImageUploadComponent {
    constructor() {
      this.allowedFileTypes = signal(Object.values(ImageType));
      this.maxFileSizeMb = signal(10);
      this.imageUploaded = new EventEmitter();
      this.uploadedImage = null;
      this.error = null;
      this.dragInProgress = false;
      this.inputId = generateUniqueId();
      this.errorId = generateUniqueId();
      this.MB_TO_BYTES_FACTOR = 1000000;
      this.BYTES_TO_MB_FACTOR = 0.000001;
      this.computeAllowedFileTypesText = () => {
        // The enum keys of the allowed file types are used since they are human-readable.
        const allowedFileTypesEnumKeys = Object.keys(ImageType).filter(key => this.allowedFileTypes().includes(ImageType[key]));
        // The number of allowed file types must be stored here before the length is modified via pop()
        const numberOfAllowedFileTypes = allowedFileTypesEnumKeys.length;
        const lastAllowedFileTypeEnumKey = allowedFileTypesEnumKeys.pop();
        switch (numberOfAllowedFileTypes) {
          case 0:
            return '';
          case 1:
            return `${lastAllowedFileTypeEnumKey} files are allowed`;
          case 2:
            return `${allowedFileTypesEnumKeys.shift()} and ${lastAllowedFileTypeEnumKey} files are allowed`;
          default:
            {
              return `${allowedFileTypesEnumKeys.join(', ')}, and ${lastAllowedFileTypeEnumKey} files are allowed`;
            }
        }
      };
      this.computeFileInputAcceptAttribute = () => {
        return this.allowedFileTypes().join(',');
      };
    }
    ngOnInit() {
      this.allowedFileTypesText = computed(this.computeAllowedFileTypesText);
      this.fileInputAcceptAttribute = computed(this.computeFileInputAcceptAttribute);
    }
    fileInputHandler() {
      const image = this.fileUpload.nativeElement.files?.[0];
      this.processUploadedImage(image);
      this.fileUpload.nativeElement.value = '';
    }
    dropHandler(event) {
      event.preventDefault();
      this.dragInProgress = false;
      const image = event.dataTransfer?.files[0];
      this.processUploadedImage(image);
    }
    dragEnterHandler(event) {
      event.preventDefault();
      this.dragInProgress = true;
    }
    dragLeaveHandler(event) {
      event.preventDefault();
      this.dragInProgress = false;
    }
    validateImage(image) {
      if (image.size > this.maxFileSizeMb() * this.MB_TO_BYTES_FACTOR) {
        this.error = `Image size exceeds the ${this.maxFileSizeMb()} MB maximum.`;
        return false;
      } else if (!this.allowedFileTypes().includes(image.type)) {
        this.error = 'File type is invalid.';
        return false;
      } else {
        this.error = null;
        return true;
      }
    }
    processUploadedImage(image) {
      if (image != null && this.validateImage(image)) {
        this.imageUploaded.emit(image);
      }
    }
    static {
      this.ɵfac = function ImageUploadComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ImageUploadComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ImageUploadComponent,
        selectors: [["fly-image-upload"]],
        viewQuery: function ImageUploadComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileUpload = _t.first);
          }
        },
        inputs: {
          label: "label",
          allowedFileTypes: [2, "allowedFileTypes", "allowedFileTypes", transformAllowedFileTypesInput],
          maxFileSizeMb: [2, "maxFileSizeMb", "maxFileSizeMb", transformMaxFileSizeMbInput]
        },
        outputs: {
          imageUploaded: "imageUploaded"
        },
        features: [i0.ɵɵInputTransformsFeature],
        decls: 20,
        vars: 9,
        consts: [["fileUpload", ""], [1, "container"], [1, "header-container"], [1, "label", 3, "for"], [3, "id"], ["type", "file", 1, "file-input", 3, "change", "id", "accept"], [1, "upload-container"], [1, "upload-description"], [1, "drop-zone", 3, "drop", "dragover", "dragenter", "dragleave"], ["icon", "upload", 1, "icon"], [1, "browse-button", 3, "click"]],
        template: function ImageUploadComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "label", 3);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ImageUploadComponent_Conditional_4_Template, 2, 2, "g-error", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "input", 5, 0);
            i0.ɵɵlistener("change", function ImageUploadComponent_Template_input_change_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.fileInputHandler());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 6)(8, "div", 7)(9, "span");
            i0.ɵɵtext(10, "Upload an image");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "span");
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 8);
            i0.ɵɵlistener("drop", function ImageUploadComponent_Template_div_drop_13_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dropHandler($event));
            })("dragover", function ImageUploadComponent_Template_div_dragover_13_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.preventDefault());
            })("dragenter", function ImageUploadComponent_Template_div_dragenter_13_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dragEnterHandler($event));
            })("dragleave", function ImageUploadComponent_Template_div_dragleave_13_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.dragLeaveHandler($event));
            });
            i0.ɵɵelement(14, "fly-icon", 9);
            i0.ɵɵelementStart(15, "span");
            i0.ɵɵtext(16, " Drag and drop or ");
            i0.ɵɵelementStart(17, "button", 10);
            i0.ɵɵlistener("click", function ImageUploadComponent_Template_button_click_17_listener() {
              i0.ɵɵrestoreView(_r1);
              const fileUpload_r3 = i0.ɵɵreference(6);
              return i0.ɵɵresetView(fileUpload_r3.click());
            });
            i0.ɵɵtext(18, " browse ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(19, " to choose an image ");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", ctx.inputId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.error != null ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.inputId)("accept", ctx.fileInputAcceptAttribute());
            i0.ɵɵattribute("aria-describedby", ctx.errorId);
            i0.ɵɵadvance(7);
            i0.ɵɵtextInterpolate(ctx.allowedFileTypesText());
            i0.ɵɵadvance();
            i0.ɵɵclassProp("drag-in-progress", ctx.dragInProgress);
          }
        },
        dependencies: [CommonModule, IconComponent, ComponentsGlobalWebModule, GError],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]{max-width:100%}.container[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:.5rem;width:max-content;max-width:100%}.header-container[_ngcontent-%COMP%]{display:flex;flex-direction:column}.upload-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;background-color:#eee;gap:1rem;padding:1rem}.upload-description[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center}.drop-zone[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;padding:.5rem;gap:.25rem;border-radius:.25rem;background:linear-gradient(90deg,#000 50%,transparent 0) repeat-x,linear-gradient(90deg,#000 50%,transparent 0) repeat-x,linear-gradient(0deg,#000 50%,transparent 0) repeat-y,linear-gradient(0deg,#000 50%,transparent 0) repeat-y;background-color:#fff;background-size:.5rem .0625rem,.5rem .0625rem,.0625rem .5rem,.0625rem .5rem;background-position:0 0,0 100%,0 0,100% 0}.drop-zone.drag-in-progress[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_border-rotation .5s infinite linear;background-image:linear-gradient(90deg,#106fad 50%,transparent 0),linear-gradient(90deg,#106fad 50%,transparent 0),linear-gradient(0deg,#106fad 50%,transparent 0),linear-gradient(0deg,#106fad 50%,transparent 0)}.drop-zone.drag-in-progress[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{pointer-events:none}@keyframes _ngcontent-%COMP%_border-rotation{to{background-position:.5rem 0,-.5rem 100%,0 -.5rem,100% .5rem}}.icon[_ngcontent-%COMP%]{height:2rem;width:2rem;color:#106fad}.browse-button[_ngcontent-%COMP%]{cursor:pointer;text-decoration:underline;transition:color .2s}.browse-button[_ngcontent-%COMP%]:active, .browse-button[_ngcontent-%COMP%]:focus{color:#333}.browse-button[_ngcontent-%COMP%]:hover{color:#333}.file-input[_ngcontent-%COMP%]{display:none}.label[_ngcontent-%COMP%]{font-weight:700;font-size:.9em}"]
      });
    }
  }
  return ImageUploadComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalButtonThemePipe = /*#__PURE__*/(() => {
  class ModalButtonThemePipe {
    transform(button) {
      if (button.disabled != null && button.disabled) {
        return 'disabled';
      } else if (button.primary != null && button.primary) {
        return 'dark';
      } else {
        return 'light';
      }
    }
    static {
      this.ɵfac = function ModalButtonThemePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalButtonThemePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "flyModalButtonTheme",
        type: ModalButtonThemePipe,
        pure: true
      });
    }
  }
  return ModalButtonThemePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalComponent = /*#__PURE__*/(() => {
  class ModalComponent {
    constructor() {
      this.showCloseBtn = true;
      this.modalClasses = '';
      this.disableExternalClose = false;
      /*
        Setting alwaysCenterButtons to true fixes the case where the combined width of the buttons is nearly identical to the width
        of the modal, which makes the buttons look like they're just off-centered even though they're actually right-aligned.
      */
      this.alwaysCenterButtons = false;
      this.closed = new EventEmitter();
      this.previousOverflowStyle = 'auto';
      this.lastMousedownEvent = null;
      this.document = inject(DOCUMENT);
    }
    open() {
      this.previousOverflowStyle = this.document.body.style.overflow;
      this.document.body.style.overflow = 'hidden';
      this.modal.nativeElement.showModal();
      this.modal.nativeElement.focus();
    }
    close() {
      this.modal.nativeElement.close();
      this.document.body.style.overflow = this.previousOverflowStyle;
      this.closed.emit();
    }
    /*
      Any mouse event within the dialog itself will not have a target tagName of "DIALOG" because it will
      have a target tagName of the actual element within the dialog. The dialog ::backdrop pseudo element
      is the only element that will have a target tagName of "DIALOG", which is what allows us to close
      the modal if that tagName is found.
         In order to make sure the click starts and ends inside the modal, it must be split into mousedown
      and mouseup. These events seem to work on iPad and mobile.
    */
    mousedownOutsideHandler(event) {
      this.lastMousedownEvent = event;
    }
    mouseupOutsideHandler(event) {
      if (event.target === this.lastMousedownEvent?.target && event.target instanceof HTMLElement && event.target.tagName === 'DIALOG' && !this.disableExternalClose) {
        this.close();
      }
      this.lastMousedownEvent = null;
    }
    /*
      The dialog HTML element already listens for the escape keydown to close the modal. We also listen for
      that event here and restore the previous overflow style.
    */
    escapeKeydownHandler(event) {
      if (this.disableExternalClose) {
        event.preventDefault();
      } else {
        this.document.body.style.overflow = this.previousOverflowStyle;
        this.closed.emit();
      }
    }
    static {
      this.ɵfac = function ModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalComponent,
        selectors: [["fly-modal"]],
        viewQuery: function ModalComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c3, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
          }
        },
        inputs: {
          header: "header",
          showCloseBtn: "showCloseBtn",
          buttons: "buttons",
          modalClasses: "modalClasses",
          disableExternalClose: "disableExternalClose",
          alwaysCenterButtons: "alwaysCenterButtons"
        },
        outputs: {
          closed: "closed"
        },
        ngContentSelectors: _c0,
        decls: 7,
        vars: 3,
        consts: [["modal", ""], ["aria-modal", "true", 1, "modal", 3, "mousedown", "mouseup", "keydown.esc", "ngClass"], [1, "modal-content-container"], [1, "modal-header"], [1, "modal-body"], [1, "modal-footer", 3, "center-buttons"], ["aria-label", "close modal", 1, "close-button"], ["aria-label", "close modal", 1, "close-button", 3, "click"], ["icon", "close"], [1, "modal-footer"], [1, "footer-button", 3, "theme"], [1, "footer-button", 3, "click", "theme"], ["type", "dark", 1, "loader"]],
        template: function ModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "dialog", 1, 0);
            i0.ɵɵlistener("mousedown", function ModalComponent_Template_dialog_mousedown_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.mousedownOutsideHandler($event));
            })("mouseup", function ModalComponent_Template_dialog_mouseup_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.mouseupOutsideHandler($event));
            })("keydown.esc", function ModalComponent_Template_dialog_keydown_esc_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.escapeKeydownHandler($event));
            });
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, ModalComponent_Conditional_3_Template, 4, 2, "div", 3);
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, ModalComponent_Conditional_6_Template, 3, 2, "div", 5);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.modalClasses);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.header != null && ctx.header.length > 0 ? 3 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.buttons != null && ctx.buttons.length > 0 ? 6 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, ComponentsGlobalWebModule, GButton, GLoader, IconComponent, ModalButtonThemePipe],
        styles: [".modal[_ngcontent-%COMP%]{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#fff;height:max-content;width:max-content;max-height:calc(100% - 2rem);max-width:calc(100% - 2rem);border-radius:.25rem}.modal[_ngcontent-%COMP%]::backdrop{background:#000;opacity:.75}.modal[open][_ngcontent-%COMP%]{display:flex}@media screen and (min-width: 1024px){.modal[_ngcontent-%COMP%]{max-height:90%;max-width:min(70%,1200px)}}.modal-content-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:auto;gap:2rem;text-align:left;padding:1.5rem 2rem}@media screen and (min-width: 768px){.modal-content-container[_ngcontent-%COMP%]{padding:2.5rem 3rem}}.modal-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:baseline;gap:2rem}@media screen and (min-width: 768px){.modal-header[_ngcontent-%COMP%]{gap:3rem}}.modal-header[_ngcontent-%COMP%] > h1[_ngcontent-%COMP%]{margin:0;flex:1 1 0}.modal-header[_ngcontent-%COMP%]   .close-button[_ngcontent-%COMP%]{height:1.5rem;width:1.5rem;cursor:pointer}@media screen and (min-width: 768px){.modal-header[_ngcontent-%COMP%]   .close-button[_ngcontent-%COMP%]{height:1.75rem;width:1.75rem}}.modal-body[_ngcontent-%COMP%]{flex:auto;overflow-y:auto}.modal-body[_ngcontent-%COMP%]:empty{display:none}.modal-footer[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;width:100%;row-gap:1rem;column-gap:2rem}.modal-footer[_ngcontent-%COMP%] > .footer-button[_ngcontent-%COMP%]{position:relative;flex:1 1 0;white-space:nowrap}@media screen and (min-width: 768px){.modal-footer[_ngcontent-%COMP%] > .footer-button[_ngcontent-%COMP%]{flex:0 0 max-content}}.modal-footer.center-buttons[_ngcontent-%COMP%]{justify-content:center}@media screen and (min-width: 768px){.modal-footer[_ngcontent-%COMP%]{justify-content:flex-end}}.hidden[_ngcontent-%COMP%]{visibility:hidden}.loader[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;top:0;left:0;padding:.5rem 1.5rem}"]
      });
    }
  }
  return ModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectFilesComponent = /*#__PURE__*/(() => {
  class SelectFilesComponent {
    constructor() {
      this.allowedFileTypes = input();
      this.filesSelected = output();
      this.selectedFiles = [];
    }
    // Handle file selection from input field
    onFileSelected(event) {
      const files = event.target.files;
      if (files.length > 0) {
        this.addFilesToSelection(files);
      }
    }
    // Handle drag over event
    onDragOver(event) {
      event.preventDefault();
    }
    // Handle drop event
    onDrop(event) {
      event.preventDefault();
      const files = event.dataTransfer?.files;
      if (files != null && files.length > 0) {
        this.addFilesToSelection(files);
      }
    }
    // Add files to the selected files array
    addFilesToSelection(files) {
      const filteredFiles = Array.from(files).filter(file => this.allowedFileTypes()?.some(type => file.name.endsWith(type)));
      if (filteredFiles.length > 0) {
        filteredFiles.forEach(file => {
          const existingFileIndex = this.selectedFiles.findIndex(f => f.name === file.name);
          if (existingFileIndex >= 0) {
            // Replace the file if it already exists
            this.selectedFiles[existingFileIndex] = file;
          } else {
            // Add the file if it doesn't exist
            this.selectedFiles.push(file);
          }
        });
        this.filesSelected.emit(this.selectedFiles);
      } else {
        alert(`Please select only the following file types: ${this.allowedFileTypes}.`);
      }
    }
    // Delete a file from the selected files array
    deleteFile(index) {
      this.selectedFiles.splice(index, 1);
      this.filesSelected.emit(this.selectedFiles);
    }
    static {
      this.ɵfac = function SelectFilesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectFilesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SelectFilesComponent,
        selectors: [["fly-select-files"]],
        inputs: {
          allowedFileTypes: [1, "allowedFileTypes"]
        },
        outputs: {
          filesSelected: "filesSelected"
        },
        decls: 13,
        vars: 1,
        consts: [["fileInput", ""], ["for", "fileUpload"], [1, "file-upload"], [1, "drop-area", 3, "dragover", "drop"], [1, "text"], [1, "browse-btn"], ["size", "medium", 3, "click"], ["type", "file", "id", "fileUpload", "multiple", "", "accept", ".zip", 1, "file-input", 3, "change"], [1, "select-files"], [1, "file-list"], [1, "file-item"], [1, "file-name"], [1, "delete-btn", 3, "click"], ["icon", "x", 1, "icon", "size-small"]],
        template: function SelectFilesComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelement(0, "label", 1);
            i0.ɵɵelementStart(1, "div", 2)(2, "div", 3);
            i0.ɵɵlistener("dragover", function SelectFilesComponent_Template_div_dragover_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDragOver($event));
            })("drop", function SelectFilesComponent_Template_div_drop_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDrop($event));
            });
            i0.ɵɵelementStart(3, "p", 4);
            i0.ɵɵtext(4, "Drag and drop files");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "p", 4);
            i0.ɵɵtext(6, "OR");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 5)(8, "g-button", 6);
            i0.ɵɵlistener("click", function SelectFilesComponent_Template_g_button_click_8_listener() {
              i0.ɵɵrestoreView(_r1);
              const fileInput_r2 = i0.ɵɵreference(11);
              return i0.ɵɵresetView(fileInput_r2.click());
            });
            i0.ɵɵtext(9, "BROWSE FOR FILES");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "input", 7, 0);
            i0.ɵɵlistener("change", function SelectFilesComponent_Template_input_change_10_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFileSelected($event));
            });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(12, SelectFilesComponent_Conditional_12_Template, 6, 0, "div", 8);
          }
          if (rf & 2) {
            i0.ɵɵadvance(12);
            i0.ɵɵconditional(ctx.selectedFiles.length > 0 ? 12 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, GButton, IconComponent],
        styles: [".file-upload[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;background-color:#eee;width:100%;height:15rem;margin-top:2rem}.drop-area[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:column;font-weight:700;background-color:#fff;outline:2px dashed #000;width:98%;height:92%;padding:1rem;text-align:center}.drop-area[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-top:2rem}.browse-btn[_ngcontent-%COMP%]{margin-bottom:2rem}.file-input[_ngcontent-%COMP%]{display:none}.select-files[_ngcontent-%COMP%]{background-color:#eee;height:fit-content;width:100%;margin-top:0}.file-list[_ngcontent-%COMP%]{padding:.5rem}.file-item[_ngcontent-%COMP%]{display:flex;justify-content:space-between;border:2px solid rgb(178.5,178.5,178.5);background-color:#fff;padding:1rem;margin-top:.5rem;font-weight:700}.delete-btn[_ngcontent-%COMP%]{font-weight:700;width:1rem;height:1rem;margin-top:4px}.select-files[_ngcontent-%COMP%]   .file-upload[_ngcontent-%COMP%]{margin-bottom:0}"]
      });
    }
  }
  return SelectFilesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TabsComponent = /*#__PURE__*/(() => {
  class TabsComponent {
    constructor() {
      this.showArrows = false;
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.destroyRef = inject(DestroyRef);
      this.cdr = inject(ChangeDetectorRef);
    }
    ngAfterViewInit() {
      new Observable(subscriber => {
        const observer = new ResizeObserver(() => subscriber.next());
        observer.observe(this.tabsInnerContainer.nativeElement);
        return () => {
          observer.disconnect();
        };
      }).pipe(debounceTime(25), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.showArrows = this.getIndexOfFirstLeftOverflowTab() !== -1 || this.getIndexOfFirstRightOverflowTab() !== -1;
        this.cdr.detectChanges();
      });
    }
    scrollRight() {
      this.tabsInnerContainer.nativeElement.children.item(this.getIndexOfFirstRightOverflowTab())?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
    scrollLeft() {
      this.tabsInnerContainer.nativeElement.children.item(this.getIndexOfFirstLeftOverflowTab())?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
    getIndexOfFirstLeftOverflowTab() {
      const reversedArray = Array.from(this.tabsInnerContainer.nativeElement.children).reverse();
      const index = reversedArray.findIndex(tab => {
        /*
          Subtract 1 from the container's left bound because when the left bound of the tab visually matches the left
          bound of the container, it differs by a small fraction which causes this condition to fail.
        */
        return tab.getBoundingClientRect().left < this.tabsInnerContainer.nativeElement.getBoundingClientRect().left - 1;
      });
      // Since the index was found on the reversed array, invert that index. If the index is -1, that means
      // a tab that overflows on the left side was not found, so we can just return -1 without any modification.
      return index === -1 ? -1 : reversedArray.length - index - 1;
    }
    getIndexOfFirstRightOverflowTab() {
      return Array.from(this.tabsInnerContainer.nativeElement.children).findIndex(tab => {
        /*
          Add 1 from the container's right bound because when the right bound of the tab visually matches the right
          bound of the container, it differs by a small fraction which causes this condition to fail.
        */
        return tab.getBoundingClientRect().right > this.tabsInnerContainer.nativeElement.getBoundingClientRect().right + 1;
      });
    }
    static {
      this.ɵfac = function TabsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TabsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TabsComponent,
        selectors: [["fly-tabs"]],
        viewQuery: function TabsComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabsInnerContainer = _t.first);
          }
        },
        inputs: {
          tabs: "tabs"
        },
        decls: 9,
        vars: 2,
        consts: [["tabsInnerContainer", ""], [1, "component-container"], [1, "tabs-outer-container"], [1, "arrow-button"], [1, "tabs-inner-container"], ["routerLinkActive", "active", 1, "tab", 3, "routerLink", "routerLinkActiveOptions"], [1, "arrow-button", 3, "click"], ["alt", "left arrow icon", 1, "icon", "left", 3, "src"], ["alt", "right arrow icon", 1, "icon", 3, "src"]],
        template: function TabsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵtemplate(2, TabsComponent_Conditional_2_Template, 2, 1, "button", 3);
            i0.ɵɵelementStart(3, "div", 4, 0);
            i0.ɵɵrepeaterCreate(5, TabsComponent_For_6_Template, 2, 4, "a", 5, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, TabsComponent_Conditional_7_Template, 2, 1, "button", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(8, "router-outlet");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showArrows ? 2 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵrepeater(ctx.tabs);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showArrows ? 7 : -1);
          }
        },
        dependencies: [CommonModule, RouterModule, i1$1.RouterOutlet, i1$1.RouterLink, i1$1.RouterLinkActive],
        styles: [".tab[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){.tab[_ngcontent-%COMP%]{font-size:1.25rem}}[_nghost-%COMP%]{display:flex;max-width:100%;height:min-content}.component-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:100%}.tabs-outer-container[_ngcontent-%COMP%]{display:flex;justify-content:center;width:100%}.tabs-inner-container[_ngcontent-%COMP%]{display:flex;width:100%;overflow-x:auto}@media screen and (min-width: 768px){.tabs-inner-container[_ngcontent-%COMP%]{overflow-x:hidden}}.tab[_ngcontent-%COMP%]{text-decoration:unset;position:relative;padding:1rem 1rem .5rem;margin:0 auto;margin-bottom:.5rem;text-transform:uppercase;height:min-content;white-space:nowrap;cursor:pointer}.tab.active[_ngcontent-%COMP%]:after{display:block;content:\"\";height:.125rem;width:100%;background:#000;position:absolute;bottom:0;left:0}.arrow-button[_ngcontent-%COMP%]{display:none;align-items:center;padding:.75rem;cursor:pointer}@media screen and (min-width: 768px){.arrow-button[_ngcontent-%COMP%]{display:flex}}.arrow-button[_ngcontent-%COMP%]:hover{background-color:#d9d9d9}.arrow-button[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{height:1rem;width:1rem}.arrow-button[_ngcontent-%COMP%]   .icon.left[_ngcontent-%COMP%]{transform:rotate(180deg)}"]
      });
    }
  }
  return TabsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UnsavedChanges = /*#__PURE__*/(() => {
  class UnsavedChanges {
    constructor() {
      this.destroyRef = inject(DestroyRef);
    }
    ngOnInit() {
      fromEvent(window, 'beforeunload').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
        if (this.unsavedChanges()) {
          event.preventDefault();
        }
      });
    }
    static {
      this.ɵfac = function UnsavedChanges_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UnsavedChanges)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: UnsavedChanges
      });
    }
  }
  return UnsavedChanges;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var WizardState = /*#__PURE__*/function (WizardState) {
  WizardState[WizardState["INCOMPLETE"] = 0] = "INCOMPLETE";
  WizardState[WizardState["COMPLETE"] = 1] = "COMPLETE";
  return WizardState;
}(WizardState || {});
var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["Warning"] = "Warning";
  MessageType["Alert"] = "Alert";
  MessageType["Info"] = "Info";
  MessageType["Success"] = "Success";
  return MessageType;
}(MessageType || {});
var AvdbPricingProductRegionGeoCoverageType = /*#__PURE__*/function (AvdbPricingProductRegionGeoCoverageType) {
  AvdbPricingProductRegionGeoCoverageType["None"] = "None";
  AvdbPricingProductRegionGeoCoverageType["Partial"] = "Partial";
  AvdbPricingProductRegionGeoCoverageType["Complete"] = "Complete";
  return AvdbPricingProductRegionGeoCoverageType;
}(AvdbPricingProductRegionGeoCoverageType || {});
/**
 * Dummy wizard header component.
 * @input WizardSteps - steps to iterate over.
 * @input currentIndex - index to start the wizard.
 */
let WizardHeaderComponent = /*#__PURE__*/(() => {
  class WizardHeaderComponent {
    constructor() {
      this.interactive = false;
      this.stepIndexSelected = new EventEmitter();
      this.WizardState = WizardState;
    }
    ngOnChanges(changes) {
      if (changes['currentIndex'] != null) {
        const newIndex = changes['currentIndex'].currentValue;
        // '+1' adds support for use case where we need to display a
        // state but not include the state in the wizard steps
        if (newIndex < 0 || newIndex >= this.wizardSteps.length + 1) {
          throw new Error('Invalid currentIndex value');
        }
      }
    }
    static {
      this.ɵfac = function WizardHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WizardHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WizardHeaderComponent,
        selectors: [["fly-wizard-header"]],
        inputs: {
          wizardSteps: "wizardSteps",
          currentIndex: "currentIndex",
          interactive: "interactive"
        },
        outputs: {
          stepIndexSelected: "stepIndexSelected"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 4,
        vars: 0,
        consts: [["stepContent", ""], [1, "step", "interactive"], [1, "step"], [1, "step", "interactive", 3, "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["icon", "checkmark-circle", 1, "icon", "complete-step"], [1, "circle", 3, "current-step"], [1, "text"], [1, "circle"]],
        template: function WizardHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, WizardHeaderComponent_For_1_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵtemplate(2, WizardHeaderComponent_ng_template_2_Template, 4, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵrepeater(ctx.wizardSteps);
          }
        },
        dependencies: [CommonModule, i1.NgTemplateOutlet, IconComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;justify-content:space-evenly;flex-wrap:wrap;gap:1rem;align-content:center;padding:1rem 0}@media screen and (min-width: 768px){[_nghost-%COMP%]{flex-direction:row;align-content:initial;gap:.5rem}}.step[_ngcontent-%COMP%]{display:flex;gap:.5rem;align-items:stretch}.step.interactive[_ngcontent-%COMP%]:hover > .icon[_ngcontent-%COMP%], .step.interactive[_ngcontent-%COMP%]:hover > .text[_ngcontent-%COMP%]{color:#106fad}.step.interactive[_ngcontent-%COMP%]:hover > .circle[_ngcontent-%COMP%]{background-color:#106fad}.step[_ngcontent-%COMP%] > .icon[_ngcontent-%COMP%]{display:flex;height:2.2rem;width:2.2rem}.step[_ngcontent-%COMP%] > .text[_ngcontent-%COMP%]{display:flex;align-items:center}.circle[_ngcontent-%COMP%]{width:2.25rem;height:2.25rem;border-radius:50%;background-color:#000;display:flex;justify-content:center;align-items:center}.circle[_ngcontent-%COMP%] > .text[_ngcontent-%COMP%]{font-family:Roboto;color:#fff;font-size:1.25rem}.current-step[_ngcontent-%COMP%]{background-color:#106fad}.complete-step[_ngcontent-%COMP%]{color:#737373;font-size:1.25rem;font-family:Oswald}.incomplete-step-text[_ngcontent-%COMP%]{color:#000;font-size:1.25rem;font-family:Oswald}"]
      });
    }
  }
  return WizardHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SearchInputComponent = /*#__PURE__*/(() => {
  class SearchInputComponent {
    constructor() {
      this.libConfig = inject(FLY_WEB_COMMON_CONFIG);
      // this is so we can highlight the input box (like g-components do)
      this.inputFocused = signal(false);
    }
    clearSearch(event) {
      event.preventDefault(); // don't take focus away from the input
      this.inputControl.reset();
    }
    static {
      this.ɵfac = function SearchInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SearchInputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SearchInputComponent,
        selectors: [["fly-search-input"]],
        inputs: {
          inputControl: "inputControl",
          label: "label"
        },
        decls: 6,
        vars: 8,
        consts: [["for", "search-input"], [1, "search-input"], ["alt", "search-icon", 3, "src"], ["id", "search-input", "name", "search-input", "type", "text", 3, "focus", "blur", "formControl"], ["alt", "clear-icon", 1, "clear", 3, "pointerdown", "src"]],
        template: function SearchInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵelement(3, "img", 2);
            i0.ɵɵelementStart(4, "input", 3);
            i0.ɵɵlistener("focus", function SearchInputComponent_Template_input_focus_4_listener() {
              return ctx.inputFocused.set(true);
            })("blur", function SearchInputComponent_Template_input_blur_4_listener() {
              return ctx.inputFocused.set(false);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "img", 4);
            i0.ɵɵlistener("pointerdown", function SearchInputComponent_Template_img_pointerdown_5_listener($event) {
              return ctx.clearSearch($event);
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("input-focus", ctx.inputFocused());
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("src", "", ctx.libConfig.regaliaIconsPath, "/search/icon.svg", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formControl", ctx.inputControl);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("src", "", ctx.libConfig.regaliaIconsPath, "/close/icon.svg", i0.ɵɵsanitizeUrl);
          }
        },
        dependencies: [CommonModule, ReactiveFormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlDirective],
        styles: [".search-input[_ngcontent-%COMP%]{border:1px solid rgb(216.75,216.75,216.75);display:flex;gap:.5rem;margin-top:.3rem;padding:0 .875rem}img[_ngcontent-%COMP%]{width:1rem}label[_ngcontent-%COMP%]{font-weight:700;font-size:.9rem}input[_ngcontent-%COMP%]{all:unset;flex-grow:1;width:100%;line-height:1.15;padding:.875rem 0}.clear[_ngcontent-%COMP%]{visibility:hidden}input[_ngcontent-%COMP%]:focus + .clear[_ngcontent-%COMP%]{visibility:visible;cursor:pointer}.input-focus[_ngcontent-%COMP%]{border:1px solid #000}"]
      });
    }
  }
  return SearchInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SortableColumnHeaderComponent = /*#__PURE__*/(() => {
  class SortableColumnHeaderComponent {
    static {
      this.ɵfac = function SortableColumnHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SortableColumnHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SortableColumnHeaderComponent,
        selectors: [["fly-sortable-column-header"]],
        inputs: {
          colName: "colName",
          sortDir: "sortDir"
        },
        decls: 5,
        vars: 5,
        consts: [[1, "sort-dir"], ["icon", "chevron-up", 1, "icon"], ["icon", "chevron-down", 1, "icon"]],
        template: function SortableColumnHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 0);
            i0.ɵɵelement(3, "fly-icon", 1)(4, "fly-icon", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.colName);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("active", ctx.sortDir() === -1);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("active", ctx.sortDir() === 1);
          }
        },
        dependencies: [CommonModule, IconComponent],
        styles: ["[_nghost-%COMP%]{display:flex;gap:.5rem;align-items:center;cursor:pointer}.sort-dir[_ngcontent-%COMP%]{display:flex;flex-direction:column}.icon[_ngcontent-%COMP%]{display:flex;color:#d9d9d9;width:.75rem;height:.75rem}.active[_ngcontent-%COMP%]{color:#000}"]
      });
    }
  }
  return SortableColumnHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PageControlsComponent = /*#__PURE__*/(() => {
  class PageControlsComponent {
    constructor() {
      this.currentPage = signal(1);
      this.maxPerPage = 5;
      this.pageChanged = new EventEmitter();
      this.showAll = new EventEmitter();
      this.count = computed(() => this.total() - this.currentPage() * this.maxPerPage < 0 ? this.total() % this.maxPerPage : this.maxPerPage);
      this.totalPages = computed(() => Math.ceil(this.total() / this.maxPerPage));
      this.hideControls = false;
    }
    onPageChanged(event) {
      this.pageChanged.emit(event.detail);
    }
    showAllToggle() {
      this.hideControls = !this.hideControls;
      this.showAll.emit(this.hideControls);
    }
    static {
      this.ɵfac = function PageControlsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PageControlsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PageControlsComponent,
        selectors: [["fly-page-controls"]],
        inputs: {
          total: "total",
          label: "label",
          currentPage: "currentPage",
          maxPerPage: "maxPerPage"
        },
        outputs: {
          pageChanged: "pageChanged",
          showAll: "showAll"
        },
        decls: 5,
        vars: 6,
        consts: [[1, "counts"], [3, "hidden"], ["size", "small"], [3, "currentPage", "totalPages"], ["size", "small", 3, "click"], [3, "g-page-changed", "currentPage", "totalPages"]],
        template: function PageControlsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, PageControlsComponent_Conditional_3_Template, 2, 1, "g-button", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, PageControlsComponent_Conditional_4_Template, 1, 2, "g-pagination", 3);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.hideControls);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate3("Showing ", ctx.count(), " of ", ctx.total(), " ", ctx.label, "");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.totalPages() > 1 ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.hideControls && ctx.totalPages() > 1 ? 4 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, GButton, GPagination],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column-reverse;gap:1rem;justify-content:center;align-items:center;padding-top:2rem}@media screen and (min-width: 768px){[_nghost-%COMP%]{flex-direction:row;justify-content:space-between}}.counts[_ngcontent-%COMP%]{display:flex;gap:1rem;align-items:center;font-weight:500;font-size:.75rem}.counts[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{flex-shrink:0}"]
      });
    }
  }
  return PageControlsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const AUTO_DISMISS_DELAY_MS = 5000;
const DISMISS_ANIMATION_DURATION_MS = 350; // This should match the $dismiss-animation-duration SCSS variable

// DO NOT INSTANTIATE THIS COMPONENT DIRECTLY. IT SHOULD ONLY BE CREATED THROUGH THE TOAST SERVICE.
let ToastComponent = /*#__PURE__*/(() => {
  class ToastComponent {
    constructor() {
      this.showDismissAnimation = false;
    }
    ngOnInit() {
      if (this.autoDismiss) {
        setTimeout(() => {
          this.dismiss();
        }, AUTO_DISMISS_DELAY_MS);
      }
    }
    dismiss() {
      this.showDismissAnimation = true;
      setTimeout(() => {
        this.componentRef.destroy();
      }, DISMISS_ANIMATION_DURATION_MS);
    }
    static {
      this.ɵfac = function ToastComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ToastComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ToastComponent,
        selectors: [["ng-component"]],
        inputs: {
          message: "message",
          style: "style",
          autoDismiss: "autoDismiss",
          serviceGeneratedId: "serviceGeneratedId",
          componentRef: "componentRef"
        },
        decls: 13,
        vars: 21,
        consts: [[1, "toast-wrapper", 3, "click", "ngClass"], [1, "toast-content"], [1, "information-container"], [1, "style-icon-wrapper", 3, "ngClass"], ["icon", "checkmark-circle"], ["icon", "info"], ["icon", "caution"], ["icon", "error"], ["aria-live", "polite"], ["aria-label", "Dismiss notification", 1, "dismiss-button", 3, "click"], [1, "dismiss-icon-wrapper", 3, "ngClass"], ["icon", "x-circle"]],
        template: function ToastComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function ToastComponent_Template_div_click_0_listener() {
              return ctx.dismiss();
            });
            i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
            i0.ɵɵtemplate(4, ToastComponent_Case_4_Template, 1, 0, "fly-icon", 4)(5, ToastComponent_Case_5_Template, 1, 0, "fly-icon", 5)(6, ToastComponent_Case_6_Template, 1, 0, "fly-icon", 6)(7, ToastComponent_Case_7_Template, 1, 0, "fly-icon", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "span", 8);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "button", 9);
            i0.ɵɵlistener("click", function ToastComponent_Template_button_click_10_listener() {
              return ctx.dismiss();
            });
            i0.ɵɵelementStart(11, "div", 10);
            i0.ɵɵelement(12, "fly-icon", 11);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            let tmp_2_0;
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(5, _c7, ctx.style === "success", ctx.style === "info", ctx.style === "caution", ctx.style === "error", ctx.showDismissAnimation));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(11, _c8, ctx.style === "success", ctx.style === "info", ctx.style === "caution", ctx.style === "error"));
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_2_0 = ctx.style) === "success" ? 4 : tmp_2_0 === "info" ? 5 : tmp_2_0 === "caution" ? 6 : tmp_2_0 === "error" ? 7 : -1);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.message);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(16, _c8, ctx.style === "success", ctx.style === "info", ctx.style === "caution", ctx.style === "error"));
          }
        },
        dependencies: [CommonModule, i1.NgClass, IconComponent],
        styles: [".toast-wrapper[_ngcontent-%COMP%]{border-radius:.25rem;color:#000;background-color:#eee;border-width:.125rem;box-shadow:#0003 0 .625rem 1.25rem,#00000040 0 .375rem .375rem;border-style:solid;width:20rem;padding:.5rem;cursor:pointer;animation:.35s ease-out _ngcontent-%COMP%_appear}.toast-wrapper.dismiss[_ngcontent-%COMP%]{animation:.35s ease-in forwards _ngcontent-%COMP%_dismiss}.toast-wrapper[_ngcontent-%COMP%]:focus-within{color:#eee;background-color:#000}@keyframes _ngcontent-%COMP%_appear{0%{transform:translate(21rem);opacity:0}to{transform:translate(0);opacity:1}}@keyframes _ngcontent-%COMP%_dismiss{0%{transform:translate(0);opacity:1}to{transform:translate(21rem);opacity:0}}.toast-wrapper.success[_ngcontent-%COMP%]{border-color:#4bb450}.toast-wrapper.info[_ngcontent-%COMP%]{border-color:#106fad}.toast-wrapper.caution[_ngcontent-%COMP%]{border-color:#ffaf33}.toast-wrapper.error[_ngcontent-%COMP%]{border-color:#920000}.toast-content[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;gap:1rem;word-break:break-word}.information-container[_ngcontent-%COMP%]{display:flex;align-items:center;gap:1rem}.style-icon-wrapper[_ngcontent-%COMP%]{flex-shrink:0;height:1.25rem;width:1.25rem}.dismiss-button[_ngcontent-%COMP%]{display:flex;align-items:center;border:none;cursor:pointer}.dismiss-icon-wrapper[_ngcontent-%COMP%]{height:1rem;width:1rem}.style-icon-wrapper[_ngcontent-%COMP%], .dismiss-icon-wrapper[_ngcontent-%COMP%]{display:flex}.success.style-icon-wrapper[_ngcontent-%COMP%], .success.dismiss-icon-wrapper[_ngcontent-%COMP%]{color:#4bb450}.info.style-icon-wrapper[_ngcontent-%COMP%], .info.dismiss-icon-wrapper[_ngcontent-%COMP%]{color:#106fad}.caution.style-icon-wrapper[_ngcontent-%COMP%], .caution.dismiss-icon-wrapper[_ngcontent-%COMP%]{color:#ffaf33}.error.style-icon-wrapper[_ngcontent-%COMP%], .error.dismiss-icon-wrapper[_ngcontent-%COMP%]{color:#920000}"]
      });
    }
  }
  return ToastComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProductOptionSeriesComponent = /*#__PURE__*/(() => {
  class ProductOptionSeriesComponent {
    constructor() {
      this.series = input.required();
      this.partKey = input.required();
      this.imageUrl = computed(() => `${GARMIN_CDN_URL}/apps/fly/img/avdb_type_regions/${this.series().region.coverageMapFilename}`);
      this.expand = signal(false);
    }
    static {
      this.ɵfac = function ProductOptionSeriesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductOptionSeriesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductOptionSeriesComponent,
        selectors: [["fly-product-option-series"]],
        inputs: {
          series: [1, "series"],
          partKey: [1, "partKey"]
        },
        decls: 11,
        vars: 7,
        consts: [[1, "series-container"], [1, "image-container"], [1, "series-name"], [1, "dropdown-button", 3, "click", "title", "flat"], [1, "dropdown"], ["icon", "chevron-up", 1, "icon", "size-small", "color-black"], ["icon", "chevron-down", 1, "icon", "size-small", "color-black"], [1, "details-expanded"], [1, "main-image", 3, "alt", "src"], [1, "image-detail", 3, "alt", "src"], [1, "coverage-details"], [1, "coverage-description-html", 3, "innerHTML"]],
        template: function ProductOptionSeriesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ProductOptionSeriesComponent_Conditional_1_Template, 2, 2, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, ProductOptionSeriesComponent_Conditional_3_Template, 4, 2, "span")(4, ProductOptionSeriesComponent_Conditional_4_Template, 3, 1, "span");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "g-button", 3);
            i0.ɵɵlistener("click", function ProductOptionSeriesComponent_Template_g_button_click_5_listener() {
              return ctx.expand.set(!ctx.expand());
            });
            i0.ɵɵelementStart(6, "span", 4);
            i0.ɵɵtext(7, " View Coverage Details ");
            i0.ɵɵtemplate(8, ProductOptionSeriesComponent_Conditional_8_Template, 1, 0, "fly-icon", 5)(9, ProductOptionSeriesComponent_Conditional_9_Template, 1, 0, "fly-icon", 6);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(10, ProductOptionSeriesComponent_Conditional_10_Template, 5, 4, "div", 7);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.expand() ? 1 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.series().region.vendorName != null ? 3 : 4);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("title", ctx.expand() ? "collapse" : "expand")("flat", true);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.expand() ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.expand() ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.expand() ? 10 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, GButton, IconComponent],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.series-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-evenly;align-items:flex-start;min-height:6rem}@media screen and (min-width: 768px){.series-container[_ngcontent-%COMP%]{flex-direction:row;gap:3rem;align-items:center;justify-content:space-between}}.image-container[_ngcontent-%COMP%]{display:none;padding:.5rem 0;width:12rem}@media screen and (min-width: 768px){.image-container[_ngcontent-%COMP%]{display:flex}}.main-image[_ngcontent-%COMP%]{width:80%}.series-name[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-start;width:14rem}@media screen and (min-width: 768px){.series-name[_ngcontent-%COMP%]{align-items:center}}.dropdown-button[_ngcontent-%COMP%]{display:flex;align-items:center}.dropdown[_ngcontent-%COMP%]{display:flex;align-items:center;gap:.5rem}.coverage-details-image[_ngcontent-%COMP%]{display:flex;justify-content:center}.details-expanded[_ngcontent-%COMP%]{display:flex;gap:2rem;flex-direction:column;align-items:stretch;padding:1rem 0 2rem}@media screen and (min-width: 768px){.details-expanded[_ngcontent-%COMP%]{flex-direction:row;align-items:center}}.image-detail[_ngcontent-%COMP%]{width:100%}@media screen and (min-width: 768px){.image-detail[_ngcontent-%COMP%]{width:50%}}.coverage-details[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:1rem}.coverage-description-html[_ngcontent-%COMP%]{flex-grow:1}"]
      });
    }
  }
  return ProductOptionSeriesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProductOptionComponent = /*#__PURE__*/(() => {
  class ProductOptionComponent {
    static {
      this.ɵfac = function ProductOptionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductOptionComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductOptionComponent,
        selectors: [["fly-product-option"]],
        inputs: {
          product: "product"
        },
        decls: 2,
        vars: 0,
        consts: [[1, "product-option-container"], [3, "partKey", "series"]],
        template: function ProductOptionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, ProductOptionComponent_For_1_Template, 2, 2, "div", 0, _forTrack0);
          }
          if (rf & 2) {
            i0.ɵɵrepeater(ctx.product.series);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, ProductOptionSeriesComponent],
        styles: [".product-option-container[_ngcontent-%COMP%]{margin-top:.5rem}"]
      });
    }
  }
  return ProductOptionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FullPageLoaderComponent = /*#__PURE__*/(() => {
  class FullPageLoaderComponent {
    static {
      this.ɵfac = function FullPageLoaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FullPageLoaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FullPageLoaderComponent,
        selectors: [["fly-full-page-loader"]],
        decls: 2,
        vars: 0,
        consts: [[1, "full-page-loader"], ["type", "dark"]],
        template: function FullPageLoaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "g-flex", 0);
            i0.ɵɵelement(1, "g-loader", 1);
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [ComponentsGlobalWebModule, GFlex, GLoader],
        styles: [".full-page-loader[_ngcontent-%COMP%]{flex-direction:column;height:20vh;align-items:center;justify-content:center}@media screen and (min-width: 768px){.full-page-loader[_ngcontent-%COMP%]{height:30vh}}.full-page-loader[_ngcontent-%COMP%]   g-loader[_ngcontent-%COMP%]{width:5rem}"]
      });
    }
  }
  return FullPageLoaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const AVDB_TYPE_LOGO_FILENAMES = new Map([[1, 'avdb-type-logo-navigation-data.svg'],
// Navigation Data
[2, 'avdb-type-logo-obstacles.svg'],
// Obstacles
[3, 'avdb-type-logo-terrain.svg'],
// Terrain
[4, 'avdb-type-logo-safetaxi.svg'],
// SafeTaxi
[5, 'avdb-type-logo-flitecharts.svg'],
// FliteCharts
[6, 'avdb-type-logo-airport-directory.svg'],
// Airport Directory
[7, 'avdb-type-logo-basemap.svg'],
// Basemap
[8, 'avdb-type-logo-chartview-key.svg'],
// ChartView Key
[9, 'avdb-type-logo-ifr-vfr-charts.svg'],
// IFR/VFR Charts
[10, 'avdb-type-logo-frequency-data.svg'],
// Frequency Data
[11, 'avdb-type-logo-d2-pilot-watch.svg'],
// D2 Pilot Watch
[12, 'avdb-type-logo-map-enhancements.svg'] // Map Enhancements
]);
let AvdbTypeLogoIconComponent = /*#__PURE__*/(() => {
  class AvdbTypeLogoIconComponent {
    constructor() {
      this.libConfig = inject(FLY_WEB_COMMON_CONFIG);
      this.avdbTypeId = input.required();
      this.alt = input.required();
      this.logoFileName = computed(() => AVDB_TYPE_LOGO_FILENAMES.get(this.avdbTypeId()));
      this.link = computed(() => `${this.libConfig.assetsPath ?? ''}assets/icons/avdb-type/${this.logoFileName()}`);
    }
    static {
      this.ɵfac = function AvdbTypeLogoIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AvdbTypeLogoIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AvdbTypeLogoIconComponent,
        selectors: [["fly-avdb-type-logo-icon"]],
        inputs: {
          avdbTypeId: [1, "avdbTypeId"],
          alt: [1, "alt"]
        },
        decls: 1,
        vars: 2,
        consts: [[3, "alt", "src"]],
        template: function AvdbTypeLogoIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "img", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("alt", ctx.alt())("src", ctx.link(), i0.ɵɵsanitizeUrl);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule],
        encapsulation: 2
      });
    }
  }
  return AvdbTypeLogoIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BreadcrumbsComponent = /*#__PURE__*/(() => {
  class BreadcrumbsComponent {
    constructor() {
      this.breadcrumbs = input.required();
    }
    static {
      this.ɵfac = function BreadcrumbsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BreadcrumbsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BreadcrumbsComponent,
        selectors: [["fly-breadcrumbs"]],
        inputs: {
          breadcrumbs: [1, "breadcrumbs"]
        },
        decls: 3,
        vars: 0,
        consts: [[1, "breadcrumbs"], [3, "routerLink"], [3, "href"]],
        template: function BreadcrumbsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵrepeaterCreate(1, BreadcrumbsComponent_For_2_Template, 3, 2, null, null, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.breadcrumbs());
          }
        },
        dependencies: [RouterLink],
        styles: [".breadcrumbs[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:last-child{font-weight:700}.breadcrumbs[_ngcontent-%COMP%]{display:flex;gap:.5rem;flex-wrap:wrap}"]
      });
    }
  }
  return BreadcrumbsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CERTIFIED_PREFIXES = ['78C', '78D', '78E', '78G', '78H', '78F', '8J3', '8J5'];
const EXPERIMENTAL_PREFIXES = ['78J', '8J2', '8J4'];
const HERCULES_SYSTEM_TYPE_IDS = [107, 120];

/**
 * The breakpoints defined in Garmin Insignia and documented
 * {@link https://designsystems.garmin.com/insignia/#breakpoints here}
 */
const InsigniaBreakpoints = {
  ExtraSmallScreen: 480,
  SmallScreen: 768,
  MediumScreen: 1024,
  LargeScreen: 1200,
  ExtraLargeScreen: 1350,
  ExtraExtraLargeScreen: 1440,
  ExtraExtraExtraLargeScreen: 1824
};
var ConnectivityDevice = /*#__PURE__*/function (ConnectivityDevice) {
  ConnectivityDevice[ConnectivityDevice["GDL_60"] = 100] = "GDL_60";
  ConnectivityDevice[ConnectivityDevice["GSR_56"] = 103] = "GSR_56";
  ConnectivityDevice[ConnectivityDevice["GDL_59"] = 108] = "GDL_59";
  ConnectivityDevice[ConnectivityDevice["C"] = 110] = "C";
  return ConnectivityDevice;
}(ConnectivityDevice || {});
// Fly Admin - Feature flags
var FeatureFlyAdmin = /*#__PURE__*/function (FeatureFlyAdmin) {
  FeatureFlyAdmin["AIRCRAFT_SETUP_WIZARD"] = "AVC_FLYADMIN_AIRCRAFT_SETUP_WIZARD";
  FeatureFlyAdmin["AUTO_RENEWALS"] = "AVC_FLYADMIN_AUTO_RENEWALS";
  FeatureFlyAdmin["ENABLE_AIRCRAFT_LOGBOOK"] = "AVC_FLYADMIN_ENABLE_AIRCRAFT_LOGBOOK";
  FeatureFlyAdmin["ENABLE_AIRCRAFT_LOGBOOK_UPLOAD"] = "AVC_FLYADMIN_ENABLE_AFL_UPLOAD";
  FeatureFlyAdmin["ENABLE_FLIGHT_LOG_SHARING"] = "AVC_FLY_ENABLE_FLIGHT_LOG_SHARING";
  FeatureFlyAdmin["GP_AUTO_RENEWALS"] = "AVC_FLYADMIN_GP_AUTO_RENEWALS";
  FeatureFlyAdmin["HYDRA"] = "AVC_FLY_WEB_ADMIN_HYDRA";
  FeatureFlyAdmin["ORGS_ROLES"] = "AVC_FLY_WEB_ADMIN_ORGS_ROLES";
  FeatureFlyAdmin["CUSTOM_ROLES"] = "AVC_FLYADMIN_ENABLE_CUSTOM_ROLES";
  FeatureFlyAdmin["HIDE_SUBSCRIPTION_MANAGEMENT"] = "AVC_FLYADMIN_HIDE_SUBSCRIPTION_MANAGEMENT";
  FeatureFlyAdmin["DESERT_ZEBRA_TELE"] = "AVC_FLYADMIN_DESERT_ZEBRA_TELE";
  FeatureFlyAdmin["AIRCRAFT_WIZARD_ADD_DEVICE_BUNDLES"] = "AVC_FLYADMIN_AIRCRAFT_WIZARD_ADD_DEVICE_BUNDLES";
  FeatureFlyAdmin["AIRCRAFT_LOGBOOK_ENTRY_DETAILS"] = "AVC_FLY_ENABLE_AIRCRAFT_LOGBOOK_ENTRY_DETAILS";
  FeatureFlyAdmin["THIRD_PARTY_AUTH"] = "AVC_FLYGARMIN_THIRD_PARTY_AUTH";
  FeatureFlyAdmin["REDEMPTION_IMPROVEMENTS"] = "AVC_FLY_ENABLE_REDEMPTION_IMPROVEMENTS";
  FeatureFlyAdmin["ENABLE_FUTURE_START_DATE"] = "AVC_FLY_ENABLE_FUTURE_START_DATE";
  FeatureFlyAdmin["ENABLE_HERCULES_CONNECTIVITY"] = "AVC_FLYADMIN_ENABLE_HERCULES_CONNECTIVITY";
  return FeatureFlyAdmin;
}(FeatureFlyAdmin || {});
// Fly Garmin - Feature flags
var FeatureFlyGarmin = /*#__PURE__*/function (FeatureFlyGarmin) {
  FeatureFlyGarmin["AIRCRAFT_LOGBOOK"] = "AVC_FLY_ENABLE_AIRCRAFT_LOGBOOK";
  FeatureFlyGarmin["AIRCRAFT_LOGBOOK_ENTRY_DETAILS"] = "AVC_FLY_ENABLE_AIRCRAFT_LOGBOOK_ENTRY_DETAILS";
  FeatureFlyGarmin["AIRCRAFT_LOGBOOK_UPLOAD"] = "AVC_FLYGARMIN_ENABLE_AFL_UPLOAD";
  FeatureFlyGarmin["AIRCRAFT_SETUP_WIZARD"] = "AVC_FLYGARMIN_AIRCRAFT_SETUP_WIZARD";
  FeatureFlyGarmin["AIRCRAFT_WIZARD_ADD_DEVICE_BUNDLES"] = "AVC_FLYGARMIN_AIRCRAFT_WIZARD_ADD_DEVICE_BUNDLES";
  FeatureFlyGarmin["AR_CHECKOUT_VALIDATION"] = "AVC_FLYGARMIN_AUTO_RENEWALS_CHECKOUT_VALIDATION";
  FeatureFlyGarmin["AR_CONFIRMATION_MESSAGE"] = "AVC_FLYGARMIN_AUTO_RENEWALS_CONFIRMATION_MESSAGE";
  FeatureFlyGarmin["AR_OEM_DEALER_TRANSFER_WARNING"] = "AVC_FLYGARMIN_AUTO_RENEWALS_OEM_DEALER_TRANSFER_WARNING";
  FeatureFlyGarmin["AR_EXPIRING_SUBSCRIPTION_EMAIL"] = "AVC_FLYGARMIN_AUTO_RENEWALS_EXPIRING_SUBSCRIPTION_EMAIL";
  FeatureFlyGarmin["AVDB_EXPIRED_SUBSCRIPTIONS"] = "AVC_FLY_AVDB_EXPIRED_SUBSCRIPTIONS";
  FeatureFlyGarmin["C_OTC_ACTIVATION"] = "AVC_FLY_GSR56C_OTC_ACTIVATION";
  FeatureFlyGarmin["CHECKOUT_MIGRATION"] = "AVC_FLYGARMIN_CHECKOUT_MIGRATION";
  FeatureFlyGarmin["CUSTOM_ROLES"] = "AVC_FLYGARMIN_ENABLE_CUSTOM_ROLES";
  FeatureFlyGarmin["DESERT_ZEBRA_TELE"] = "AVC_FLYGARMIN_DESERT_ZEBRA_TELE";
  FeatureFlyGarmin["DISABLE_CHECKOUT"] = "AVC_FLYGARMIN_DISABLE_CHECKOUT";
  FeatureFlyGarmin["ENABLE_DESERTZEBRA"] = "AVC_FLYGARMIN_ENABLE_DESERTZEBRA";
  FeatureFlyGarmin["ENABLE_FLIGHT_LOG_SHARING"] = "AVC_FLY_ENABLE_FLIGHT_LOG_SHARING";
  FeatureFlyGarmin["ENABLE_FUTURE_START_DATE"] = "AVC_FLY_ENABLE_FUTURE_START_DATE";
  FeatureFlyGarmin["ENABLE_HERCULES"] = "AVC_FLYGARMIN_ENABLE_HERCULES";
  FeatureFlyGarmin["ENABLE_HERCULES_CONNECTIVITY"] = "AVC_FLYGARMIN_ENABLE_HERCULES_CONNECTIVITY";
  FeatureFlyGarmin["ENABLE_HYDRA"] = "AVC_FLYGARMIN_ENABLE_HYDRA";
  FeatureFlyGarmin["ENABLE_NEW_AIRCRAFT_LIST_PAGE"] = "AVC_FLYGARMIN_ENABLE_NEW_AIRCRAFT_LIST_PAGE";
  FeatureFlyGarmin["ENABLE_PROMO_CREDITS_GP_TRIAL_PROMOTION"] = "AVC_FLYGARMIN_PROMO_CREDITS_GP_TRIAL_PROMOTION";
  FeatureFlyGarmin["ENABLE_SOFTWARE_ORDERING"] = "AVC_FLYGARMIN_ENABLE_SOFTWARE_ORDERING";
  FeatureFlyGarmin["ENABLE_QR_AIRCRAFT_REGISTRATION"] = "AVC_FLYGARMIN_QR_AIRCRAFT_REGISTRATION_ENABLED";
  FeatureFlyGarmin["ENABLE_X3"] = "AVC_FLYGARMIN_ENABLE_X3";
  FeatureFlyGarmin["ENABLE_SYSID_BYPASS"] = "AVC_FLYGARMIN_ENABLE_SYSID_BYPASS";
  FeatureFlyGarmin["GP_AUTO_RENEWALS"] = "AVC_FLYGARMIN_GP_AUTO_RENEWALS";
  FeatureFlyGarmin["HIDE_SUBSCRIPTION_MANAGEMENT"] = "AVC_FLYGARMIN_HIDE_SUBSCRIPTION_MANAGEMENT";
  FeatureFlyGarmin["HYDRA"] = "AVC_FLY_WEB_HYDRA";
  FeatureFlyGarmin["ORGS_ROLES"] = "AVC_FLY_WEB_ORGS_ROLES";
  FeatureFlyGarmin["PROMO_CREDITS_TERM_EXTENSIONS"] = "AVC_FLYGARMIN_PROMO_CREDITS_TERM_EXTENSIONS";
  FeatureFlyGarmin["REDEMPTION_IMPROVEMENTS"] = "AVC_FLY_ENABLE_REDEMPTION_IMPROVEMENTS";
  FeatureFlyGarmin["SUBSCRIPTIONS_EARLY_RENEWAL"] = "AVC_FLY_SUBSCRIPTIONS_EARLY_RENEWAL";
  FeatureFlyGarmin["SUBSCRIPTIONS_YARMOUTH_RENEWAL_PRICE"] = "AVC_FLY_SUBSCRIPTIONS_YARMOUTH_RENEWAL_PRICE";
  FeatureFlyGarmin["THIRD_PARTY_AUTH"] = "AVC_FLYGARMIN_THIRD_PARTY_AUTH";
  FeatureFlyGarmin["YARMOUTH_API_GET_COUPON_V2"] = "AVC_FLY_YARMOUTH_API_GET_COUPON_V2";
  return FeatureFlyGarmin;
}(FeatureFlyGarmin || {});
var OrgFunction = /*#__PURE__*/function (OrgFunction) {
  OrgFunction[OrgFunction["AIRCRAFT_MANAGEMENT"] = 1] = "AIRCRAFT_MANAGEMENT";
  OrgFunction[OrgFunction["AVIONICS_SOFTWARE"] = 2] = "AVIONICS_SOFTWARE";
  OrgFunction[OrgFunction["CABIN_BRIEFER"] = 3] = "CABIN_BRIEFER";
  OrgFunction[OrgFunction["CMC_CONFIG"] = 4] = "CMC_CONFIG";
  OrgFunction[OrgFunction["CONNECTED_COCKPIT_DEVICES"] = 5] = "CONNECTED_COCKPIT_DEVICES";
  OrgFunction[OrgFunction["DATABASE_MANAGEMENT"] = 6] = "DATABASE_MANAGEMENT";
  OrgFunction[OrgFunction["DEVICE_MANAGEMENT"] = 7] = "DEVICE_MANAGEMENT";
  OrgFunction[OrgFunction["ELECTRONIC_DOCS"] = 8] = "ELECTRONIC_DOCS";
  OrgFunction[OrgFunction["FILE_MANAGEMENT"] = 9] = "FILE_MANAGEMENT";
  OrgFunction[OrgFunction["LIVE_SENSOR_QUERY"] = 10] = "LIVE_SENSOR_QUERY";
  OrgFunction[OrgFunction["OEM_DIAGNOSTICS"] = 11] = "OEM_DIAGNOSTICS";
  OrgFunction[OrgFunction["ORGANIZATION_MANAGEMENT"] = 12] = "ORGANIZATION_MANAGEMENT";
  OrgFunction[OrgFunction["PRODUCTION_LINE_DATABASES"] = 13] = "PRODUCTION_LINE_DATABASES";
  OrgFunction[OrgFunction["PROTECTED_CHECKLISTS"] = 14] = "PROTECTED_CHECKLISTS";
  OrgFunction[OrgFunction["SUBSCRIPTIONS"] = 15] = "SUBSCRIPTIONS";
  OrgFunction[OrgFunction["USER_CHECKLISTS"] = 16] = "USER_CHECKLISTS";
  OrgFunction[OrgFunction["WARRANTY"] = 17] = "WARRANTY";
  OrgFunction[OrgFunction["DEALER_ACCESS_MANAGEMENT_DEALER"] = 18] = "DEALER_ACCESS_MANAGEMENT_DEALER";
  OrgFunction[OrgFunction["DEALER_ACCESS_MANAGEMENT_CUSTOMER"] = 19] = "DEALER_ACCESS_MANAGEMENT_CUSTOMER";
  OrgFunction[OrgFunction["TELEPHONY"] = 20] = "TELEPHONY";
  OrgFunction[OrgFunction["AIRCRAFT_REGISTRATION"] = 21] = "AIRCRAFT_REGISTRATION";
  OrgFunction[OrgFunction["AVIONICS_SOFTWARE_RESTRICTED"] = 22] = "AVIONICS_SOFTWARE_RESTRICTED";
  OrgFunction[OrgFunction["FEDERATED_CONFIGURATION"] = 23] = "FEDERATED_CONFIGURATION";
  OrgFunction[OrgFunction["FEDERATED_CONFIGURATION_RESTRICTED"] = 24] = "FEDERATED_CONFIGURATION_RESTRICTED";
  OrgFunction[OrgFunction["FLIGHT_LOGS"] = 25] = "FLIGHT_LOGS";
  OrgFunction[OrgFunction["SYSTEM_ID_BYPASS"] = 26] = "SYSTEM_ID_BYPASS";
  OrgFunction[OrgFunction["ENABLEMENTS_RESTRICTED"] = 27] = "ENABLEMENTS_RESTRICTED";
  OrgFunction[OrgFunction["ORACLE_BILLING"] = 28] = "ORACLE_BILLING";
  return OrgFunction;
}(OrgFunction || {});
/** [NOTE]
 * Permission -> { name = ID }
 * PChecklist = OEM
 * UChecklist = Operator
 */
var Permission = /*#__PURE__*/function (Permission) {
  Permission[Permission["NONE"] = -1] = "NONE";
  Permission[Permission["AIRCRAFT_EDIT"] = 10] = "AIRCRAFT_EDIT";
  Permission[Permission["AIRCRAFT_TRANSFER"] = 11] = "AIRCRAFT_TRANSFER";
  Permission[Permission["AIRCRAFT_READ"] = 12] = "AIRCRAFT_READ";
  Permission[Permission["AIRCRAFT_SHARE"] = 13] = "AIRCRAFT_SHARE";
  Permission[Permission["LSQ_RECEIVE"] = 14] = "LSQ_RECEIVE";
  Permission[Permission["LSQ_TRIGGER"] = 15] = "LSQ_TRIGGER";
  Permission[Permission["AIRCRAFT_DELETE"] = 16] = "AIRCRAFT_DELETE";
  Permission[Permission["CCD_CONNEXT_TRIAL"] = 17] = "CCD_CONNEXT_TRIAL";
  Permission[Permission["CCD_ACTIVATE_DEVICE"] = 18] = "CCD_ACTIVATE_DEVICE";
  Permission[Permission["AVIONICS_SW_READ"] = 19] = "AVIONICS_SW_READ";
  Permission[Permission["AVIONICS_SW_PURCHASE"] = 20] = "AVIONICS_SW_PURCHASE";
  Permission[Permission["AVIONICS_SW_DOWNLOAD"] = 21] = "AVIONICS_SW_DOWNLOAD";
  Permission[Permission["CABIN_BRIEFER_UPLOAD"] = 22] = "CABIN_BRIEFER_UPLOAD";
  Permission[Permission["CABIN_BRIEFER_DOWNLOAD"] = 23] = "CABIN_BRIEFER_DOWNLOAD";
  Permission[Permission["CABIN_BRIEFER_READ"] = 24] = "CABIN_BRIEFER_READ";
  Permission[Permission["CMC_CONFIG_UPLOAD"] = 25] = "CMC_CONFIG_UPLOAD";
  Permission[Permission["CMC_CONFIG_DOWNLOAD"] = 26] = "CMC_CONFIG_DOWNLOAD";
  Permission[Permission["CMC_CONFIG_READ"] = 27] = "CMC_CONFIG_READ";
  Permission[Permission["AVDB_READ"] = 28] = "AVDB_READ";
  Permission[Permission["AVDB_PURCHASE"] = 30] = "AVDB_PURCHASE";
  Permission[Permission["AVDB_DOWNLOAD"] = 31] = "AVDB_DOWNLOAD";
  Permission[Permission["DEVICE_READ"] = 32] = "DEVICE_READ";
  Permission[Permission["DEVICE_EDIT"] = 33] = "DEVICE_EDIT";
  Permission[Permission["EDOCS_UPLOAD"] = 34] = "EDOCS_UPLOAD";
  Permission[Permission["EDOCS_DOWNLOAD"] = 35] = "EDOCS_DOWNLOAD";
  Permission[Permission["EDOCS_READ"] = 36] = "EDOCS_READ";
  Permission[Permission["OEMD_UPLOAD"] = 37] = "OEMD_UPLOAD";
  Permission[Permission["OEMD_DOWNLOAD"] = 38] = "OEMD_DOWNLOAD";
  Permission[Permission["OEMD_READ"] = 39] = "OEMD_READ";
  Permission[Permission["ORGANIZATION_READ"] = 40] = "ORGANIZATION_READ";
  Permission[Permission["ORGANIZATION_EDIT"] = 41] = "ORGANIZATION_EDIT";
  Permission[Permission["ORGANIZATION_DELETE"] = 42] = "ORGANIZATION_DELETE";
  Permission[Permission["ORGANIZATION_TRANSFER"] = 43] = "ORGANIZATION_TRANSFER";
  Permission[Permission["MEMBER_READ"] = 44] = "MEMBER_READ";
  Permission[Permission["MEMBER_EDIT"] = 45] = "MEMBER_EDIT";
  Permission[Permission["AVDB_PRODUCTION"] = 46] = "AVDB_PRODUCTION";
  Permission[Permission["PCHECKLIST_CREATE"] = 47] = "PCHECKLIST_CREATE";
  Permission[Permission["PCHECKLIST_UPLOAD"] = 48] = "PCHECKLIST_UPLOAD";
  Permission[Permission["PCHECKLIST_DOWNLOAD"] = 49] = "PCHECKLIST_DOWNLOAD";
  Permission[Permission["PCHECKLIST_READ"] = 50] = "PCHECKLIST_READ";
  Permission[Permission["SUBSCRIPTION_EDIT"] = 51] = "SUBSCRIPTION_EDIT";
  Permission[Permission["SUBSCRIPTION_READ"] = 52] = "SUBSCRIPTION_READ";
  Permission[Permission["UCHECKLIST_UPLOAD"] = 53] = "UCHECKLIST_UPLOAD";
  Permission[Permission["UCHECKLIST_DOWNLOAD"] = 54] = "UCHECKLIST_DOWNLOAD";
  Permission[Permission["UCHECKLIST_READ"] = 55] = "UCHECKLIST_READ";
  Permission[Permission["WARRANTY_EDIT"] = 56] = "WARRANTY_EDIT";
  Permission[Permission["WARRANTY_READ"] = 57] = "WARRANTY_READ";
  Permission[Permission["AIRCRAFT_3PARTY_SHARING"] = 58] = "AIRCRAFT_3PARTY_SHARING";
  Permission[Permission["GRANT_DEALER_ACCESS"] = 59] = "GRANT_DEALER_ACCESS";
  Permission[Permission["ORGANIZATION_ROLES_EDIT"] = 75] = "ORGANIZATION_ROLES_EDIT";
  return Permission;
}(Permission || {});
// DO NOT EXPORT THIS FOR USAGE OUTSIDE OF THE UNSAVED CHANGES SERVICE
let UnsavedChangesModalComponent = /*#__PURE__*/(() => {
  class UnsavedChangesModalComponent {
    constructor() {
      this.navigationConfirmed = new EventEmitter();
      this.leave = () => {
        this.navigationConfirmed.emit(true);
        this.close();
      };
      this.cancel = () => {
        this.navigationConfirmed.emit(false);
        this.close();
      };
    }
    open() {
      this.modal.open();
    }
    close() {
      this.modal.close();
    }
    static {
      this.ɵfac = function UnsavedChangesModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UnsavedChangesModalComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UnsavedChangesModalComponent,
        selectors: [["fly-unsaved-changes-modal"]],
        viewQuery: function UnsavedChangesModalComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(ModalComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
          }
        },
        inputs: {
          componentRef: "componentRef"
        },
        outputs: {
          navigationConfirmed: "navigationConfirmed"
        },
        decls: 3,
        vars: 11,
        consts: [[3, "header", "buttons", "showCloseBtn", "alwaysCenterButtons"]],
        template: function UnsavedChangesModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "fly-modal", 0)(1, "p");
            i0.ɵɵtext(2, "Changes made will not be saved.");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("header", "Are you sure you want to leave?")("buttons", i0.ɵɵpureFunction2(8, _c11, i0.ɵɵpureFunction1(4, _c9, ctx.leave), i0.ɵɵpureFunction1(6, _c10, ctx.cancel)))("showCloseBtn", false)("alwaysCenterButtons", true);
          }
        },
        dependencies: [CommonModule, ModalComponent, ComponentsGlobalWebModule],
        encapsulation: 2
      });
    }
  }
  return UnsavedChangesModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// DO NOT EXPORT THIS FOR USAGE OUTSIDE OF THE UNSAVED CHANGES GUARD
let UnsavedChangesService = /*#__PURE__*/(() => {
  class UnsavedChangesService {
    constructor() {
      this.document = inject(DOCUMENT);
      this.renderer = inject(RendererFactory2).createRenderer(null, null);
      this.environmentInjector = inject(EnvironmentInjector);
      this.applicationRef = inject(ApplicationRef);
      this.destroyRef = inject(DestroyRef);
    }
    confirmNavigation() {
      const modalHost = this.renderer.createElement('div');
      this.renderer.appendChild(this.document.body, modalHost);
      const modal = createComponent(UnsavedChangesModalComponent, {
        hostElement: modalHost,
        environmentInjector: this.environmentInjector
      });
      modal.setInput('componentRef', modal);
      this.applicationRef.attachView(modal.hostView);
      modal.changeDetectorRef.detectChanges();
      modal.instance.open();
      modal.instance.modal.closed.pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe(() => this.renderer.removeChild(this.document.body, modalHost));
      return modal.instance.navigationConfirmed.asObservable();
    }
    static {
      this.ɵfac = function UnsavedChangesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UnsavedChangesService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UnsavedChangesService,
        factory: UnsavedChangesService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return UnsavedChangesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const unsavedChangesGuard = component => {
  const unsavedChangesService = inject(UnsavedChangesService);
  return !component.unsavedChanges() || unsavedChangesService.confirmNavigation();
};
let ArrayIncludesPipe = /*#__PURE__*/(() => {
  class ArrayIncludesPipe {
    transform(array, value) {
      return array.includes(value);
    }
    static {
      this.ɵfac = function ArrayIncludesPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ArrayIncludesPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "flyArrayIncludes",
        type: ArrayIncludesPipe,
        pure: true
      });
    }
  }
  return ArrayIncludesPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var TimeFormat = /*#__PURE__*/function (TimeFormat) {
  TimeFormat["AbbreviatedDate"] = "MMM dd, yyyy";
  TimeFormat["FullDate"] = "MMMM d, y";
  return TimeFormat;
}(TimeFormat || {});
let FormattedDatePipe = /*#__PURE__*/(() => {
  class FormattedDatePipe {
    transform(value, format = 'AbbreviatedDate', timeZone = null) {
      const formattedDate = timeZone == null ? formatDate(value, TimeFormat[format], 'en-US') : formatDate(value, TimeFormat[format], 'en-US', timeZone);
      return formattedDate != null ? formattedDate : value.toString();
    }
    static {
      this.ɵfac = function FormattedDatePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormattedDatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "flyFormattedDate",
        type: FormattedDatePipe,
        pure: true
      });
    }
  }
  return FormattedDatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * flyPermissionCheck - Pipe to check for a permission from the list of the Permissions.
 *
 * @example Basic usage
 * permissions | flyPermissionCheck: Permission.AIRCRAFT_READ
 */
let PermissionCheckPipe = /*#__PURE__*/(() => {
  class PermissionCheckPipe {
    transform(permissions, requiredPermission) {
      if (permissions == null || permissions?.length === 0 || requiredPermission == null) return false;
      return permissions.some(permission => permission.name === Permission[requiredPermission]);
    }
    static {
      this.ɵfac = function PermissionCheckPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PermissionCheckPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "flyPermissionCheck",
        type: PermissionCheckPipe,
        pure: true
      });
    }
  }
  return PermissionCheckPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const nullAndUndefinedFilter = item => item != null;

/**
 * Meant to be used in an array's `sort` method. Sorts an array by string properties which may be nully.
 *
 * @param a String A to test.
 * @param b String B to test.
 * @param nullStringTakesPriority If `true`, null strings will be sorted before strings with values. Nully strings will appear last if `false`.
 * @returns A number less than 0 if `a` should be before `b`, a number greater than 0 if `a` should be after `b`, 0 otherwise.
 */
const nullSafeStringSort = (a, b, nullStringTakesPriority = true) => {
  if (a != null && b != null) {
    return a.localeCompare(b);
  }
  if (a == null && b != null) {
    return nullStringTakesPriority ? -1 : 1;
  }
  if (a != null && b == null) {
    return nullStringTakesPriority ? 1 : -1;
  }
  return 0;
};

/* eslint-disable max-len */
/**
 * RegEx used is the {@link https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address | HTML Standard}
 */
const emailRegEx = new RegExp(/^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/);
let AircraftPromotionValidatorService = /*#__PURE__*/(() => {
  class AircraftPromotionValidatorService {
    constructor() {
      this.aircraftReadonlyControllerService = inject(AircraftReadOnlyControllerService);
      this.yarmouthConnextValidationService = inject(YarmouthConnextValidationService);
    }
    validateAircraftForPromotion(aircraft) {
      if (aircraft.masterAircraftUuid != null) {
        return of(null);
      }
      let validationError = null;
      const yarmouthSerialNumberValidation$ = this.yarmouthConnextValidationService.validateAircraftSerialNumber(this.generateSerialNumberValidationRequest(aircraft)).pipe(catchError(err => {
        validationError = 'YARMOUTH_VALIDATION_REQUEST_FAILED';
        return throwError(() => err);
      }));
      const aircraftPromoteValidation$ = this.aircraftReadonlyControllerService.validatePromotion(aircraft.aircraftUuid).pipe(catchError(err => {
        const message = err.error.errorText;
        if (message.includes('Aircraft system already exists for system id')) {
          validationError = 'DUPLICATE_SYSTEM_IDS';
        } else if (message.includes('promote request serial number are empty')) {
          validationError = 'NULL_SERIAL_NUMBER';
        } else if (message.includes(`Aircraft with model id = ${aircraft.model?.id} cannot be promoted to a master aircraft.`)) {
          validationError = 'INVALID_MAKE_AND_MODEL';
        } else if (message.includes('Master aircraft already exists for tail number')) {
          validationError = 'INVALID_TAIL_NUMBER';
        } else {
          validationError = 'COREDATA_VALIDATION_REQUEST_FAILED';
        }
        return throwError(() => err);
      }));
      return forkJoin([yarmouthSerialNumberValidation$, aircraftPromoteValidation$]).pipe(
      // aircraft promote response return nothing if it was a success
      // so just check the Yarmouth serial number response
      tap(([yarmouthSerialNumberResponse]) => {
        if (yarmouthSerialNumberResponse.isValid) {
          validationError = null;
        } else {
          const errorMessage = yarmouthSerialNumberResponse.error;
          if (errorMessage.includes('Aircraft serial number is invalid.')) {
            validationError = 'INVALID_SERIAL_NUMBER';
          } else {
            console.error(yarmouthSerialNumberResponse.error);
            validationError = 'INVALID_AIRCRAFT_CONFIGURATION';
          }
        }
      }), map(() => validationError), catchError(() => of(validationError)));
    }
    generateSerialNumberValidationRequest(aircraft) {
      const {
        model,
        systems,
        serialNumber
      } = aircraft;
      return {
        flyDeviceModelId: systems?.flatMap(system => system.devices?.map(d => d.deviceId).filter(nullAndUndefinedFilter) ?? []),
        makeId: model?.make?.id,
        modelId: model?.id,
        serialNumber: serialNumber ?? ''
      };
    }
    static {
      this.ɵfac = function AircraftPromotionValidatorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AircraftPromotionValidatorService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AircraftPromotionValidatorService,
        factory: AircraftPromotionValidatorService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AircraftPromotionValidatorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const GARMIN_GLOBAL_STORAGE_COOKIE_NAME = 'GarminGlobalStorage';
const GARMIN_GLOBAL_STORAGE_PATH_DOMAIN = '; path=/; domain=.garmin.com;';
/**
 * This service sets and gets cookies based on a 'path' specified
 * The path translates like this: setGlobal('locale', 'es-UK') => 'GarminGlobalStorage={"global":{"locale":"es-UK"}};'
 * Hierarchical paths convert to objects: setGlobal('level1.level2', 'value') => 'GarminGlobalStorage={"global":{ "level1": {"level2": "value"} }};'
 */
let GarminGlobalStoreService = /*#__PURE__*/(() => {
  class GarminGlobalStoreService {
    constructor() {
      this.cookieService = inject(CookieService);
      this.cookies = signal({});
      this.cookies.set(this.getGlobalStorage());
    }
    /**
     * get cookie by path
     * @param path cookie path (ie. 'acManagement.aircraft.make')
     * @returns the value of the cookie at the path if it exists; otherwise, returns false
     */
    getGlobal(path) {
      const globalPath = path && path.length > 0 ? `global.${path}` : 'global';
      let branch = this.getGlobalStorage();
      const keys = globalPath.split('.');
      for (const key of keys) {
        if (Object.keys(branch).some(storageKey => storageKey === key)) {
          branch = branch[key];
        } else {
          return undefined;
        }
      }
      return branch;
    }
    /**
     * set cookie at path with value
     * @param path cookie path (ie. 'acManagement.aircraft.make')
     * @param value value to set
     */
    setGlobal(path, value) {
      const globalPath = path && path.length > 0 ? `global.${path}` : 'global';
      const globalStorage = this.getGlobalStorage();
      let branch = globalStorage;
      const keys = globalPath.split('.');
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (i === keys.length - 1) {
          branch[key] = value;
        } else {
          if (Object.keys(branch).some(storageKey => storageKey === key)) {
            branch = branch[key];
          } else {
            branch = branch[key] = {};
          }
        }
      }
      this.cookieService.set(GARMIN_GLOBAL_STORAGE_COOKIE_NAME, encodeURIComponent(JSON.stringify(globalStorage)), GARMIN_GLOBAL_STORAGE_PATH_DOMAIN);
      this.cookies.set(this.getGlobalStorage());
    }
    removeGlobal(path) {
      const keys = ['global', ...path.split('.')];
      const globalStorage = this.getGlobalStorage();
      let branch = globalStorage;
      for (const key of keys.slice(0, -1)) {
        if (key in branch) {
          branch = branch[key];
        }
      }
      const key = keys.at(-1);
      if (branch != null && key != null && key in branch) {
        delete branch[key];
      }
      this.cookieService.set(GARMIN_GLOBAL_STORAGE_COOKIE_NAME, encodeURIComponent(JSON.stringify(globalStorage)), GARMIN_GLOBAL_STORAGE_PATH_DOMAIN);
      this.cookies.set(this.getGlobalStorage());
    }
    /**
     * get all cookies
     * @returns the GarminGlobalStorage cookie object
     */
    getGlobalStorage() {
      const globalStorage = this.cookieService.get(GARMIN_GLOBAL_STORAGE_COOKIE_NAME);
      if (globalStorage != null) {
        return JSON.parse(decodeURIComponent(globalStorage));
      }
      return {};
    }
    static {
      this.ɵfac = function GarminGlobalStoreService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GarminGlobalStoreService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: GarminGlobalStoreService,
        factory: GarminGlobalStoreService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return GarminGlobalStoreService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UserTypeService = /*#__PURE__*/(() => {
  class UserTypeService {
    constructor() {
      this.userConfigCache = null;
      this.userOrgContextCache = null;
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.garminGlobalStoreService = inject(GarminGlobalStoreService);
      this.organizationReadOnlyControllerService = inject(OrganizationReadOnlyControllerService);
      this.http = inject(HttpClient);
      this.localStorageService = inject(LocalStorageService);
    }
    getUserTypes() {
      const userTypes = {
        isCustomerUser: false,
        isDealerUser: false,
        isOemUser: false
      };
      return forkJoin([this.getUserConfig(), this.getUserOrgContext()]).pipe(map(([userConfig, userOrgContext]) => {
        if (userOrgContext != null) {
          userTypes.isOemUser = userOrgContext.types?.some(orgType => orgType.id === 1) ?? false;
          userTypes.isDealerUser = userOrgContext.types?.some(orgType => orgType.id === 2) ?? false;
          userTypes.isCustomerUser = userOrgContext.types?.some(orgType => orgType.id === 3) ?? false;
        } else {
          userTypes.isOemUser = userConfig.isOemUser;
          userTypes.isDealerUser = userConfig.isDealerUser;
          userTypes.isCustomerUser = userConfig.isCustomerUser;
        }
        return userTypes;
      }), catchError(error => {
        console.error(error);
        userTypes.isCustomerUser = true;
        return of(userTypes);
      }));
    }
    getUserConfig() {
      const customerGuid = this.localStorageService.get(LocalStorageKey.OAuthTokenResponse)?.customerId;
      if (this.userConfigCache == null || this.userConfigCache.loggedInUserCustomerGuid !== customerGuid) {
        return this.http.get(`${FlyGarminLegacyBaseUrl[this.config.environment]}/api/user-info`).pipe(tap(config => this.userConfigCache = config));
      }
      return of(this.userConfigCache);
    }
    getUserOrgContext() {
      const organizationUuid = this.garminGlobalStoreService.getGlobal('org.uuid');
      if (organizationUuid === undefined) {
        return of(null);
      }
      if (this.userOrgContextCache == null) {
        return this.organizationReadOnlyControllerService.getOrganizationSummary(organizationUuid).pipe(tap(orgSummary => this.userOrgContextCache = orgSummary));
      }
      return of(this.userOrgContextCache);
    }
    static {
      this.ɵfac = function UserTypeService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserTypeService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserTypeService,
        factory: UserTypeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return UserTypeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ToastService = /*#__PURE__*/(() => {
  class ToastService {
    constructor(document, rendererFactory2, environmentInjector, applicationRef) {
      this.document = document;
      this.rendererFactory2 = rendererFactory2;
      this.environmentInjector = environmentInjector;
      this.applicationRef = applicationRef;
      this.containerInitialized = false;
      this.idCounter = 0;
      this.activeToasts = new Map();
      this.renderer = this.rendererFactory2.createRenderer(null, null);
    }
    ngOnDestroy() {
      this.dismissAllToasts();
      this.toastContainer?.remove();
    }
    /**
     * @param message The text to display. Aim to keep this short.
     * @param style Defaults to `info`. Options include: `success`, `info`, `caution`, and `error`
     * @param autoDismiss Defaults to `false`. If true, the toast is automatically dismissed without
     *  any user interaction required
     */
    createToast(message, style = 'info', autoDismiss = false) {
      if (!this.containerInitialized) {
        this.initializeContainer();
      }
      const toastWrapper = this.renderer.createElement('div');
      this.renderer.appendChild(this.toastContainer, toastWrapper);
      const toastComponentRef = createComponent(ToastComponent, {
        hostElement: toastWrapper,
        environmentInjector: this.environmentInjector
      });
      toastComponentRef.onDestroy(() => {
        this.activeToasts.delete(toastComponentRef.instance.serviceGeneratedId);
      });
      toastComponentRef.setInput('message', message);
      toastComponentRef.setInput('style', style);
      toastComponentRef.setInput('autoDismiss', autoDismiss);
      toastComponentRef.setInput('serviceGeneratedId', this.idCounter);
      toastComponentRef.setInput('componentRef', toastComponentRef);
      this.applicationRef.attachView(toastComponentRef.hostView);
      this.activeToasts.set(this.idCounter, toastComponentRef.instance);
      this.idCounter += 1;
    }
    dismissAllToasts() {
      this.activeToasts.forEach(toast => {
        toast.dismiss();
      });
      this.activeToasts.clear();
      this.idCounter = 0;
    }
    initializeContainer() {
      this.toastContainer = this.renderer.createElement('div');
      this.renderer.setProperty(this.toastContainer, 'id', 'toast-container');
      this.renderer.setStyle(this.toastContainer, 'display', 'flex');
      this.renderer.setStyle(this.toastContainer, 'flex-direction', 'column-reverse');
      this.renderer.setStyle(this.toastContainer, 'position', 'fixed');
      this.renderer.setStyle(this.toastContainer, 'bottom', '0');
      this.renderer.setStyle(this.toastContainer, 'right', '0');
      this.renderer.setStyle(this.toastContainer, 'gap', '1rem');
      this.renderer.setStyle(this.toastContainer, 'padding', '1.25rem');
      this.renderer.appendChild(this.document.body, this.toastContainer);
      this.containerInitialized = true;
    }
    static {
      this.ɵfac = function ToastService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ToastService)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i0.EnvironmentInjector), i0.ɵɵinject(i0.ApplicationRef));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ToastService,
        factory: ToastService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ToastService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AVDB_TYPE_LOGO_FILENAMES, AircraftPromotionValidatorService, ArrayIncludesPipe, AutoCompleteInputComponent, AvdbPricingProductRegionGeoCoverageType, AvdbTypeLogoIconComponent, BreadcrumbsComponent, CERTIFIED_PREFIXES, CollapsibleStepComponent, ComponentsGlobalWebModule, ConnectivityDevice, DIRECTIVES, EXPERIMENTAL_PREFIXES, FeatureFlyAdmin, FeatureFlyGarmin, FormattedDatePipe, FullPageLoaderComponent, GARMIN_GLOBAL_STORAGE_COOKIE_NAME, GARMIN_GLOBAL_STORAGE_PATH_DOMAIN, GAccordion, GAlert, GBanner, GBreadcrumb, GBreadcrumbs, GBrowserAlert, GButton, GButtonContainer, GButtonGroup, GCard, GCardContainer, GCheckbox, GChip, GCollapsibleRegion, GColorSwatches, GCopy, GDropDown, GError, GFlex, GFullImage, GGlobalStyles, GHeading, GHelpText, GHeroRotator, GHorizontalLayout, GInput, GKicker, GListTable, GLoader, GPagination, GPhotoGrid, GPrice, GRadio, GShowMore, GSkeleton, GSpacer, GSpotlight, GStepper, GSubNav, GSwitch, GTextarea, GTile, GTooltip, GVerticalNav, GVideoBanner, GVideoContainer, GarminGlobalStoreService, HERCULES_SYSTEM_TYPE_IDS, IconComponent, ImageType, ImageUploadComponent, InsigniaBreakpoints, MessageType, ModalComponent, MultiSelectButtonGroupDemo, OrgFunction, PageControlsComponent, PaginationDemo, Permission, PermissionCheckPipe, ProductOptionComponent, ProductOptionSeriesComponent, SearchInputComponent, SelectFilesComponent, SingleSelectButtonGroupDemo, SortableColumnHeaderComponent, TabsComponent, TimeFormat, ToastComponent, ToastService, UnsavedChanges, UserTypeService, WizardHeaderComponent, WizardState, emailRegEx, nullAndUndefinedFilter, nullSafeStringSort, unsavedChangesGuard };
